// // ------dev-------
// // ดีงข้อมูลจาก server ibm
// const GET_LOAN_FROM_SERVER_IBM = "/lawyer/server/loans";

// //ดึงสัญญาทั้งหมดที่อยู่ใน server lawyers db
// const GET_ALL_LOAN = "/lawyer/dev/api/loans";

// //ดึงสัญญาตาม contno ที่อยู่ใน server lawyers
// const GET_LOAN_BY_CONTNO = "/lawyer/dev/api/loans/";

// //ดึงจำนวนงานที่ users รับงาน
// const GET_JOB_COUNT = "/lawyer/dev/api/loans/notics/count";

// //ดึงจำนานงานที่กำลังดำเนินการ
// const GET_JOB_IN_PROGRESS = "/lawyer/dev/api/jobs";

// //ดึงจำนานงานที่กำลังดำเนินการตามสถานะ
// const GET_JOB_IN_PROGRESS_BY_STATUS = "/lawyer/dev/api/jobs/";

// //นำข้อมูลเข้า db lawyers
// const POST_LOAN_IN_LAWYERS_DB = "/lawyer/dev/api/loans";

// //เปลี่ยนสถานะสัญญา
// const POST_STATUS = "/lawyer/dev/api/loans/status";

// //อัพเดทสถานะสัญญา
// const PUT_STATUS = "/lawyer/dev/api/loans/status";

// //ดึงข้อมูลแบบคำฟ้อง
// const GET_LAWSUIT_DETAIL_BY_ID = `/lawyer/dev/api/lawsuits/`;
// const GET_LAWSUIT_LIST = `/lawyer/dev/api/lawsuits`;
// //อัพเดทข้อมูลคำฟ้อง
// const PUT_LAWSUIT_DETAIL = `/lawyer/dev/api/lawsuits`;
// const GET_LAWSUIT_DETAIL_BY_LOAN = `/lawyer/dev/api/lawsuits/loan/`;

// //ดึงข้อมูลสืบทรัพย์
// const GET_INVESTIGATE_BY_LAWSUIT = `/lawyer/dev/api/investigate-properties/`;
// const GET_INVESTIGATE_LIST = `/lawyer/dev/api/investigate-properties`;
// //สร้างข้อมูลสืบทรัพย์
// const POST_INVESTIGATE_LOG = `/lawyer/dev/api/investigate-log`;
// const POST_INVESTIGATE_ITEM = `/lawyer/dev/api/investigate-properties`;
// //อัพเดทข้อมูลสืบทรัพย์
// const PUT_INVESTIGATE_LOG = `/lawyer/dev/api/investigate-log`;
// const PUT_INVESTIGATE_ITEM_BY_ID = `/lawyer/dev/api/investigate-properties`;
// //ดึงข้อมูลเพื่อสืบทรัพย์
// const GET_INVESTIGATE_LOANS_LIST = `/lawyer/dev/api/investigate-properties/loans/list`;
// //ข้อมูลลักษณะที่ดิน
// const GET_LAND_DETAIL_LIST = `/lawyer/dev/api/investigate-properties/details/list`;

// //สืบก่อนฟ้อง
// const POST_PRE_INVESTIGATE_LOG = `/lawyer/dev/api/pre-investigate-assets`;
// const POST_PRE_INVESTIGATE_REPORT = `/lawyer/dev/api/pre-investigate-assets-report`;

// //ข้อมูลทั้งหมดของ id
// const GET_WORK_LOG_DETAIL_BY_ID = `/lawyer/dev/api/worklogs/`;

// //คำพิพากษา
// const POST_JUDGE = `/lawyer/dev/api/judgements`;
// const PUT_JUDGE = `/lawyer/dev/api/judgements`;
// const GET_JUDGE_BY_ID = `/lawyer/dev/api/judgements/`;
// const GET_JUDGE_LIST = `/lawyer/dev/api/judgements`;

// //ข้อมูลจำเลย
// const POST_JUDGE_DEFENDANTS = `/lawyer/dev/api/judgement-defendants`;
// const PUT_JUDGE_DEFENDANTS = `/lawyer/dev/api/judgement-defendants`;
// const GET_JUDGE_DEFENDANTS_BY_ID = `/lawyer/dev/api/judgement-defendants/`;

// //ข้อมูลจทำยอม
// const POST_AGREEMENTS = `/lawyer/dev/api/agreements/`;
// const PUT_AGREEMENTS = `/lawyer/dev/api/agreements`;
// const GET_AGREEMENTS_BY_ID = `/lawyer/dev/api/agreements/`;

// //notice
// const POST_PARCELS = `/lawyer/dev/api/parcels`;
// const PUT_PARCELS = `/lawyer/dev/api/parcels`;
// const GET_PARCELS = `/lawyer/dev/api/parcels/worklogs/`;

// //ems terminate
// const POST_CANCEL = `/lawyer/dev/api/cancel-contracts`;
// const PUT_CANCEL = `/lawyer/dev/api/cancel-contracts`;
// const GET_CANCEL = `/lawyer/dev/api/cancel-contracts`;

// //expenses
// const POST_EXPENSES = `/lawyer/dev/api/expenses`;
// const PUT_EXPENSES = `/lawyer/dev/api/expenses/`;
// const GET_EXPENSES_LIST = `/lawyer/dev/api/expenses`;
// const GET_EXPENSES_CONTNO_LIST = "/lawyer/dev/api/expenses/contract-list";
// const GET_EXPENSES_LOAN_ID = `/lawyer/dev/api/expenses/loan/`;
// const GET_EXPENSES_CONTNO = `/lawyer/dev/api/expenses/contract/`;
// const POST_DELETE_ID = `/lawyer/dev/api/expenses/`;
// const GET_EXPENSE_REF_GROUP = `/lawyer/dev/api/expenses/reference-list`;
// const GET_EXPENSE_TYPE_LIST = "/lawyer/dev/api/expenses/types";

// //expenses status
// const POST_EXPENSES_REFERENCE = `/lawyer/dev/api/expenses-reference`;
// const PUT_EXPENSES_REFERENCE = `/lawyer/dev/api/expenses-reference`;
// const GET_EXPENSES_REFERENCE = `/lawyer/dev/api/expenses/reference-list`;

// //execute
// const POST_EXECUTE_CASE = "/lawyer/dev/api/execute-case";
// const PUT_EXECUTE_CASE = "/lawyer/dev/api/execute-case";
// const GET_EXECUTE_CASE = "/lawyer/dev/api/execute-case";

// //ดึง users ในระบบ
// const GET_LAWYERS_LIST = "/lawyer/dev/api/users";
// const GET_COMPANIES_LIST = "/lawyer/dev/api/companies";
// const GET_COMPANIES_LIST_NEW = `/api-new/find-company`;
// const GET_ROLE_LIST = "/lawyer/dev/api/roles";
// const GET_USERS_LIST = "/lawyer/dev/api/users";
// const GET_BY_ID = "/lawyer/dev/api/users/";
// const GET_SELL_STATUS = "/lawyer/dev/api/sale-status";

// //post
// const LOG_IN = `/lawyer/dev/api/login`;
// const REGISTER = `/lawyer/dev/api/register`;
// const POST_USER = `/lawyer/dev/api/users`;
// const PUT_USER_UPDATE = `/lawyer/dev/api/customers`;

// //รับเงินลูกค้า
// const POST_RECEIVE_PAYMENT = `/lawyer/dev/api/payment-logs`;
// const PUT_RECEIVE_PAYMENT = `/lawyer/dev/api/payment-logs`;
// const GET_RECEIVE_PAYMENT = `/lawyer/dev/api/payment-logs`;
// const GET_RECEIVE_PAYMENT_BY_PARAMS = `/lawyer/dev/api/payment-logs`;
// const DELETE_RECEIVE_PAYMENT_BY_ID = `/lawyer/dev/api/payment-logs/`;

// //all details
// const GET_DETAILS = `/lawyer/dev/api/all-details?contractNo=`;

// //method delete
// const DELETE_WORKLOG = `/lawyer/dev/api/worklogs/`;
// const DELETE_CANCEL_CONTRACTS = `/lawyer/dev/api/cancel-contracts/`;
// const DELETE_PARCELS = `/lawyer/dev/api/parcels/`;
// const DELETE_AGREEMENTS = `/lawyer/dev/api/agreements/`;
// const DELETE_JUDGEMENTS = `/lawyer/dev/api/judgements/`;
// const DELETE_JUDGEMENT_DEFENDANTS = `/lawyer/dev/api/judgement-defendants/`;
// const DELETE_INVESTIGATE_PROPERTIES = `/lawyer/dev/api/investigate-properties/`;
// const DELETE_EXPENSES = `/lawyer/dev/api/expenses/`;

// // const baseUrl = "https://shark-app-j9jc9.ondigitalocean.app";
// const baseUrl = "https://assessmentsapi-317162740896.asia-southeast3.run.app";

// const TOKEN = localStorage.getItem("TOKEN");
// const HEADERS_EXPORT = {
//   "x-access-token": TOKEN,
// };

// const HEADERS_EXPORT_DETAIL = {
//   Authorization: TOKEN,
// };

// const HEADERS_EXPORT_BEN = {
//   "Content-Type": "application/json",
//   Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
// };

// const HEADERS_LOGIN = {
//   "Content-Type": "application/json",
// };

// const BASE_URL_BEN =
//   "https://api-asset-investigation-539174983798.asia-southeast1.run.app";
// const BASE_URL_BEN_NIKKI = `https://api-nikki-539174983798.asia-southeast1.run.app`;
// // const BASE_URL_BEN_NIKKI = `http://localhost:8070`;
// // const BASE_URL_BEN = `http://localhost:8080`;

// //get ข้อมูลบอกเลิกสัญญาเบน
// const POST_TERMINATE_CONTRACT = `${BASE_URL_BEN_NIKKI}/api-lawyer/nikki`;
// const POST_TERMINATE_CONTRACT_RECORD = `${BASE_URL_BEN_NIKKI}/api-lawyer/nikki2-v2`;
// const POST_TERMINATE_BY_CONTRACT = `${BASE_URL_BEN_NIKKI}/api-lawyer/detail-contno`;

// //ค้นหาสัญญา เบน
// const POST_LOAN_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/search-contno`;
// const POST_LOAN_DB2_V2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/search-contno-v2`;

// //ข้อมูลการผ่อน เส้น 1,3,8(ที่ดิน)
// const POST_DETAIL_PAYMENT = `${BASE_URL_BEN_NIKKI}/api-lawyer/tonbalance`;

// //ข้อมูลการผ่อน 8(ไม่ใช่ดิน)
// const POST_DETAIL_PAYMENT_LEASING = `https://api-nikki-539174983798.asia-southeast1.run.app/api-lawyer/leasing`;

// //หาสัญญาที่ขาดการติดต่อเพื่อส่งสืบทรัพย์ (60 ,120, 180)
// const POST_PRE_INVESTIGATE_CHECK = `${BASE_URL_BEN_NIKKI}/api-lawyer/check-miss-call-`;

// //memo สืบทรัพย์
// const POST_LOAD_MEMO = `${BASE_URL_BEN_NIKKI}/api-lawyer/load-memo1`;
// const POST_LOAD_MEMO_NEW = `https://api-nikki-1024031113167.asia-southeast1.run.app/api-lawyer/memo1-contract`;
// const POST_UPDATE_EXCEL_MEMO = `${BASE_URL_BEN_NIKKI}/api-lawyer/updates-excel-memo1`;
// const POST_UPDATE_MEMO = `${BASE_URL_BEN_NIKKI}/api-lawyer/updates-memo1`;

// //หาทุนทรัพย์
// const POST_LITIGATION_FUNDS = `${BASE_URL_BEN_NIKKI}/api-lawyer/getleasingcase`; //เส้นจริง

// //รอบของบอกเลิก
// const GET_SELECT_RE_PRINT = `${BASE_URL_BEN}/api-new/select-re-print`;
// //ข้อมูลรีปริ้นท์
// const POST_DATA_RE_PRINT = `${BASE_URL_BEN_NIKKI}/api-lawyer/load-data-re-print`;

// //api จัดการบอกเลิก
// const POST_CANCEL_LIST = "/api-new/load-work-cancel-contract-new";
// const POST_NEW_LOAN = "/api-new/create-wcc-new";
// const POST_UPDATE_PARCEL = "/api-new/update-parcel";
// const POST_UPDATE_PARCEL_STATUS = "/api-new/update-parcel-status";

// //ceo เลือกสัญญา
// const POST_PRE_INVESTIGATE = `/api-new/create-inv-new`; //ส่งสืบ
// const POST_CANCEL_HAND_PRE = `/api-new/pre-wcc`; //บอกเลิกมือ
// const POST_PRE_INVESTIGATE_CANCEL_HAND = `/api-new/mix-wcc-hand-inv`; //กดทั้งสอง

// //เบลส่งสืบ
// const POST_MAIN_INVESTIGATE_ONLINE = `/api-new/load-inves-round`;
// const POST_LIST_INVESTIGATE_ONLINE = `/api-new/load-data-list-inves`; //get list for update & export
// const PUT_STATUS_INVESTIGATE_ONLINE = `/api-new/send-inves-round`; //ส่งสถานะ 1->2
// const GET_LIST_INVESTIGATE_ONLINE = `/api-new/all-inves-round`; //ข้อมูลรอบ
// const POST_SEND_RESPONE_INVESTIGATE = `/api-new/enter-detail-asset`;
// const POST_LIST_ASSET = `/api-new/load-list-asset`;
// const POST_EDIT_ASSET = "/api-new/update-asset";
// const POST_MAIN_ASSET_BY_DATE = "/api-new/load-main-asset";
// const POST_MAIN_ASSET_BY_CONTNO = "/api-new/search-contno-asset";
// const POST_MAIN_ASSET_BY_STATUS = "/api-new/search-status-asset";
// const POST_REPORT_INVES = `/api-new/report-inves`;

// //ออกบอกเลิกมือ
// const GET_CHECK_JOB_CANCEL_ROUND = `${BASE_URL_BEN}/api-new/select-all-round-wcc`;
// const POST_CHECK_JOB_CANCEL_HAND = `${BASE_URL_BEN}/api-new/select-round-wcc`; //รอบที่จะส่ง
// const POST_CHECK_JOB_DETIAL_CANCEL_HAND = `${BASE_URL_BEN}/api-new/load-wcc`; //ดึงข้อมูลออก excel
// const POST_CHECK_PRE_WCC = `${BASE_URL_BEN}/api-new/load-pre-wcc`; //ดึงข้อมูลออก excel
// const PUT_STATUS_ROUND = `${BASE_URL_BEN}/api-new/update-response`; //อัพเดทว่าข้อมูลเลขไปรษณีย์ครบ
// const POST_CANCEL_HAND = `${BASE_URL_BEN}/api-new/create-wcc-hand-new`; //ปอส่งออกบอกเลิก
// const PUT_STATUS_SEND = `${BASE_URL_BEN}/api-new/update-send-pre-wcc`; //ปอส่งออกบอกเลิก
// const POST_LOAD_WCC_DAY = `${BASE_URL_BEN}/api-new/load-wcc-day`; //ปอส่งออกบอกเลิก
// const POST_CHECK_ADD_CANCEL_HAND = `${BASE_URL_BEN_NIKKI}/api-lawyer/check-add-contno`;
// const GET_LIST_CANCEL_HAND_DATE = `${BASE_URL_BEN}/api-new/all-wcc-day`;

// //ข้อมูลรอบเดือน
// const POST_LOAD_BY_DATE = "/api-new/query-work-cancel-contract-new";

// //ข้อมูลตาม query เลขสัญญา, เลขไปรษณีย์, ชื่อ-สกุล
// const POST_LOAD_BY_QUERY = "/api-new/query-work-cancel-contract-new-2";

// //get GeoThailand ของเอื้อ
// const GET_PROVICE = `https://eua-i67f6gaaqa-as.a.run.app/Api/provinces`;
// const GET_DISTRICT = `https://eua-i67f6gaaqa-as.a.run.app/Api/districted/`;
// const GET_SUB_DISTRICT = `https://eua-i67f6gaaqa-as.a.run.app/Api/subdistricted/`;
// const GET_ZIPCODE = `https://eua-i67f6gaaqa-as.a.run.app/Api/zipcodes/`;

// //get GeoThailand ที่ดิน
// const GET_PROVICE_LAND = `https://onemoney.ngrok.app/GetProvince`;
// const POST_DISTRICT_LAND = `https://onemoney.ngrok.app/GetAmphur`;
// const POST_CALCULATE_LAND = `https://onemoney.ngrok.app/AllData`;

// //get GeoThailand ดริฟ
// const GET_PROVICE_DB = `/lawyer/lands/provinces`;
// const POST_DISTRICT_DB = `/lawyer/lands/districts`;
// const POST_SUB_DISTRICT_DB = `/lawyer/lands/sub-districts`;

// // ------------------------------------------------ เริ่มต้นลงพื้นที่และเพิ่มทรัพย์ ------------------------------------------------ //
// // สำหรับลงวันที่ที่จะลงพื้นที่
// // const POST_LOAD_MAIN_INVESTIGATION = `http://localhost:8070/api-inv/load-main-investigation`; // ดึงข้อมูลการลงพื้นที่หลัก
// // const POST_ADD_ASSETTHASLOAN = `http://localhost:8070/api-inv/add-assethasloan`; // ลงวันที่ที่จะลงพื้นที่
// const POST_LOAD_MAIN_INVESTIGATION = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/load-main-investigation`; // ดึงข้อมูลการลงพื้นที่หลัก
// const POST_ADD_ASSETTHASLOAN = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/add-assethasloan`; // ลงวันที่ที่จะลงพื้นที่

// // สำหรับลงพิกัดตาม Google Map
// const GET_ADD_COORDINATES = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/add-coordinates`; // เพิ่มพิกัด

// // สำหรับทรัพย์
// // const POST_LOAD_ASSET = `http://localhost:8070/api-inv/load-asset`; // add asset (เพิ่มทรัพย์) type : create
// // const POST_LOAD_MAIN_ASSET = `http://localhost:8070/api-inv/load-main-addasset`; // add asset (เพิ่มทรัพย์) type : create
// // const POST_ADD_ASSET = `http://localhost:8070/api-inv/add-asset`; // add asset (เพิ่มทรัพย์) type : create
// // const POST_EDIT_ASSET = `http://localhost:8070/api-inv/update-asset`; // edit asset (แก้ไขทรัพย์) type : update
// // const DELETE_ASSET = `http://localhost:8070/api-inv/delete-asset`; // delete asset (ลบทรัพย์) แบบไม่มีทรัพย์
// // const DELETE_ASSETLANDAREA = `http://localhost:8070/api-inv/delete-assetlandarea`; // delete asset (ลบทรัพย์) แบบมีทรัพย์
// // const EDIT_CUSTOMER_ASSET = `http://localhost:8070/api-inv/update-ac`; // edit customer asset (แก้ไขเจ้าของทรัพย์)
// // const DELETE_CUSTOMER_ALL_ASSET = `http://localhost:8070/api-inv/delete-clc`; // delete customer asset (ลบเจ้าของทรัพย์)
// // const DELETE_CUSTOMER_ONE_ASSET = `http://localhost:8070/api-inv/delete-clc-one`; // delete customer asset (ลบเจ้าของทรัพย์)
// const POST_LOAD_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/load-asset`; // add asset (เพิ่มทรัพย์) type : create
// const POST_LOAD_MAIN_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/load-main-addasset`; // add asset (เพิ่มทรัพย์) type : create
// const POST_ADD_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/add-asset`; // add asset (เพิ่มทรัพย์) type : create
// const DELETE_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/delete-asset`; // delete asset (ลบทรัพย์) แบบไม่มีทรัพย์
// const DELETE_ASSETLANDAREA = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/delete-assetlandarea`; // delete asset (ลบทรัพย์) แบบมีทรัพย์
// const EDIT_CUSTOMER_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/update-ac`; // edit customer asset (แก้ไขเจ้าของทรัพย์)
// const DELETE_CUSTOMER_ALL_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/delete-clc`; // delete customer asset (ลบเจ้าของทรัพย์)
// const DELETE_CUSTOMER_ONE_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/delete-clc-one`; // delete customer asset (ลบเจ้าของทรัพย์)

// // สำหรับรูปภาพ
// // const POST_UPLOAD_IMAGE = `http://localhost:8090/api-lawyer/upload-image-area`; // upload image (เพิ่มรูปภาพ)
// // const GET_LOAD_IMAGE = `http://localhost:8090/apimg-pdf/getImages`; // load images (โหลดรูปภาพ)
// // const DELETE_IMAGE = `http://localhost:8090/api-lawyer/delete-image-area`; // delete images (ลบรูปภาพ) ทีละรูป ฝนหน้าแก้ไข
// // const DELETE_IMAGE_NOT_ASSET = `http://localhost:8090/api-lawyer/delete-urlpath`; // delete images (ลบรูปภาพ) ทีละรูป ฝนหน้าแก้ไข
// const POST_UPLOAD_IMAGE = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/api-lawyer/upload-image-area`; // upload image (เพิ่มรูปภาพ)
// const GET_LOAD_IMAGE = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/apimg-pdf/getImages`; // load images (โหลดรูปภาพ)
// const DELETE_IMAGE = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/api-lawyer/delete-image-area`; // delete images (ลบรูปภาพ)
// const DELETE_IMAGE_NOT_ASSET = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/api-lawyer/delete-urlpath`; // delete images (ลบรูปภาพ) ทีละรูป ฝนหน้าแก้ไข

// // ------------------------------------------------ สิ้นสุดลงพื้นที่และเพิ่มทรัพย์ ------------------------------------------------ //

// const GET_GEO_ALL = `${BASE_URL_BEN}/api-new/data-area`;

// //ดู detail คำฟ้อง
// const POST_LAWSUIT_DETAIL = `${BASE_URL_BEN}/api-new/detail-lawsult`;
// const POST_NOTIC_LAWSUIT = `${BASE_URL_BEN}/api-new/lawsult`; // เฮียกดและอัพเดท
// const POST_CREATE_LAWSUIT = `${BASE_URL_BEN}/api-new/lawsult-lawyer`; //ทนายสร้างคำฟ้อง
// const POST_BACK_CASE_NUMBER = `${BASE_URL_BEN}/api-new/update-black-case`; //อัพเดทเลขคดีดำ
// const POST_UPDATE_EXPENSE = `${BASE_URL_BEN}/api-new/updates-expense-list`; //อัพเดทยอดเงิน

// //ธุรการเตรียมเอกสาร
// const POST_ACCEPT_DOC = `${BASE_URL_BEN}/api-new/accept-doc-ad`;
// const POST_DOC_SUCCESS = `${BASE_URL_BEN}/api-new/check-doc-ad`;

// //เบลตรวจเอกสาร
// const POST_CHECK_DOC = `${BASE_URL_BEN}/api-new/main-lawsult-doc`;
// const POST_ACCEPT_WORK = `${BASE_URL_BEN}/api-new/accept-check-doc`;
// const POST_DOC_STATUS = `${BASE_URL_BEN}/api-new/upsert-lawsult-doc`;
// const POST_DOC_RESEND = `${BASE_URL_BEN}/api-new/resend-lawsult-doc`;

// //เพิ่มทร.14
// const POST_ADD_ADDRESS_TR = `${BASE_URL_BEN}/api-new/add-address-tr`;

// //main lawyer
// const POST_MAIN_LAWYER = `${BASE_URL_BEN}/api-new/main-lawsult`;
// const POST_ACCEPT_LAWYER = `${BASE_URL_BEN}/api-new/accept-lawyer`;
// // ทนายอุธรณ์
// const POST_APPEAL_LAWYER = `${BASE_URL_BEN}/api-new/lawsult-appeal-lawyer`;

// //advance payment lawsuit
// const POST_MAIN_WITHDRAW = `${BASE_URL_BEN}/api-new/main-withdraw`;
// const POST_EXPENSE_LIST = `${BASE_URL_BEN}/api-new/load-expense-list`;
// const POST_UPDATE_BILL = `${BASE_URL_BEN}/api-new/update-bill`;
// const POST_MAIN_PAYMENT = `${BASE_URL_BEN}/api-new/main-payment`;
// const POST_CLEAR_PAYMENT = `${BASE_URL_BEN}/api-new/clear-payment`;
// const POST_CHECK_BILL = `${BASE_URL_BEN}/api-new/check-advane-pay`;

// //แม่ทม
// const POST_MAIN_ADVANCE_PAY = `${BASE_URL_BEN}/api-new/main-advane-pay`;
// const POST_APPROVALADVANE_PAY = `${BASE_URL_BEN}/api-new/approval-advane-pay`;
// const POST_BILL_DETAIL = `${BASE_URL_BEN}/api-new/list-payment`;
// const POST_CLEAR_APPROVAL = `${BASE_URL_BEN}/api-new/approval-clear-payment`;
// const POST_PRINT_FLAG = `${BASE_URL_BEN}/api-new/update-flag-print`;

// //พิพากษา
// const POST_LOAD_GURANTOR = `${BASE_URL_BEN}/api-new/load-requisite`;
// const POST_STATUS_JUDGMENT = `${BASE_URL_BEN}/api-new/work-judge`; //เลื่อนวันนัดศาล  + ถอนฟ้อง + ลงคำพิพากษา
// const POST_ADD_DEFENDANT = `${BASE_URL_BEN}/api-new/add-customer-judge`; //เพิ่มจำเลย
// const POST_UPDATE_ENFORCE_CASE_DATE = `${BASE_URL_BEN}/api-new/update-enforce-case-date`; //หมายตั้ง
// const POST_UPDATE_FINAL_CASE_DATE = `${BASE_URL_BEN}/api-new/update-final-case-date`; ////คดีถึงที่สุด

// const HEADERS_UPIMAGE = {
//   Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
// };
// const BASE_URL_IMAGE =
//   "https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app";
// // upload img
// const POST_UPLOAD_IMAGE_NEW = `${BASE_URL_IMAGE}/api-lawyer/upload-gather-image`; //upload
// const GET_LOAD_IMAGE_NEW_ALL = `${BASE_URL_IMAGE}/api-lawyer/load-gather-image`; //load img
// const GET_LOAD_IMAGE_NEW_BY = `${BASE_URL_IMAGE}/apimg-pdf/get-gather-image`; //แสดงรูป
// const POST_DELETE_IMAGE_NEW = `${BASE_URL_IMAGE}/apimg-pdf/delete-gather-image`; //ลบรูป

// //contnoDetail
// const POST_CONTNO_DETAIL_SEARCH = `${BASE_URL_BEN}/auth/load-detail-new-contno`; //รายละเอียดสัญญา
// const POST_CONTNO_DETAIL = `${BASE_URL_BEN}/auth/main-payment-contno`;
// const POST_CALCULATE_CONTNO_NEW = `${BASE_URL_BEN}/auth/calculate-new-contno`;
// //ตารางดิว
// const POST_LOAD_DATA_DUEPAYMENT = `${BASE_URL_BEN}/api-new/load-data-duepayment`; /* ตารางดิว ทำยอม */
// const POST_PREVIEW_BEEYPUP = `${BASE_URL_BEN}/api-new/preview-beeypup`; /* พรีวิว เบี้ยปรับ ทำยอม */
// const POST_PREVIEW_JUDGE = `${BASE_URL_BEN}/api-new/preview-Judge`; /* พรีวิว ยอดจ่าย พิพากษา ปกติ */
// //บันทึกติดตาม
// const POST_FOLLOW_CUSTOMER = `${BASE_URL_BEN}/api-new/find-tmp-tel`;

// //โหลดข้อมูลเก่า ใบเสร็จชำระหลังฟ้อง
// const GET_MAIN_OLD_DATA = `${BASE_URL_BEN}/api-new/load-main-old-data`;
// const POST_LOAD_DETAIL_OLD_DATA = `${BASE_URL_BEN}/api-new/load-detail-old-data`;
// const POST_UPDATE_JUDGE = `${BASE_URL_BEN}/api-new/check-old-data`;
// const POST_BILL_PAYMENT = `${BASE_URL_BEN}/api-new/doc-payment`;

// //ตรวจคำพิพากษา เบล
// const POST_MAIN_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/main-jugde-doc`;
// const POST_ACCEPT_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/accept-check-jugde`;
// const POST_JUDGE_DOC_DETAIL = `${BASE_URL_BEN}/api-new/detail-judge`;
// const POST_RECHECK_COMPLETE_JUDGE_DOC = `${BASE_URL_BEN}/api-new/complete-check-jugde`;
// const POST_RESEND_COMPLETE_JUDGE_DOC = `${BASE_URL_BEN}/api-new/resend-check-jugde`;

// //ตรวจคำพิพากษาเฮีย
// const POST_ACCEPT_CEO_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/accept-ceo-check-jugde`;
// const POST_CEO_RECHECK_COMPLETE_JUDGE_DOC = `${BASE_URL_BEN}/api-new/complete-ceo-check-jugde`;

// //การเงินรับชำระรายวัน
// const POST_REPORT_PAYMENT_DAILY = `${BASE_URL_BEN}/auth/report-payment-daily`;
// const POST_REPORT_AROTHR_DAILY = `${BASE_URL_BEN}/auth/report-payment-arothr-daily`;
// const POST_REPORT_SUMMARY_PAYMENT = `${BASE_URL_BEN}/auth/report-all-payment-date-daily`; //ดูรวม รับปกติ, ลูกหนี้ือื่น ๆ
// const POST_CONTNO_PAYMENT_DAILY = `${BASE_URL_BEN}/auth/report-all-payment-daily`; // ดูรายสัญญา

// // //รายงานการขายผ่อน
// const POST_REPORT_SELLING = `${BASE_URL_BEN}/auth/report-sdate-contno`;
// const POST_REPORT_SELLING_AND_INSTALLMENTS = `${BASE_URL_BEN}/auth/report-cash-sale-contno`;
// const POST_REPORT_DEBIT_BALANCE = `${BASE_URL_BEN}/auth/report-debit-balance`;

// //ใบเสร็จเบิกทดลอง
// const GET_LOAD_BANK = `${BASE_URL_BEN_NIKKI}/api-lawyer/load-bank`;
// const POST_ADVANE_PAY_DB2 = `${BASE_URL_BEN}/api-new/advane-pay-db2`;
// const POST_PRINT_ADVANCE_PAY_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/print-advane-pay-db2`;

// //ใบเสร็จเคลียร์เบิกทดลอง
// const POST_CLEAR_PAYMENT_DB2 = `${BASE_URL_BEN}/api-new/clear-pay-db2`;
// const POST_PRINT_CLEAR_PAYMENT_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/print-clear-pay-db2`;

// //รายงานตั้งเบิก/เคลียร์เงินทดรอง
// const POST_REPORT_DAILY_ADVANCE_PAY_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/report-daily-advane-pay-db2`;
// const POST_REPORT_DAILY_ADVANCE_CLEAR_PAY_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/report-daily-clear-pay-db2`;

// //memo new
// const POST_INSERT_NOTE_NEW = `${BASE_URL_BEN}/api-new/insert-note`;

// //เพิ่มรอบส่งใบชำระทำยอม
// const POST_ROUND_AGREEMENT = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/update-rounddate-jn`; //รอบ
// const POST_EMS_AGREEMENT = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/update-parcelno-jn`; //ยิง ems

// //บัญชีตรวจสอบ
// const POST_ACCEPT_ACC_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/accept-acc-check-jugde`;
// const POST_COMPLETE_ACC_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/complete-acc-check-jugde`;
// const POST_CHECK_HD_PAYMENT = `${BASE_URL_BEN_NIKKI}/api-lawyer/check-hd-payment-impound `; //เช็ครับฝาก

// const HEADERS_NPL = {
//   "X-API-Key": "SMART_NPL_SECRET_2026",
// };
// const BASE_URL_NPL =
//   "https://accounting-npl-api-test-539174983798.asia-southeast1.run.app";

// // get ตาม phase
// const GET_NPL_CLOSE_OLD_CONTNO = `${BASE_URL_NPL}/api/v1/preview-npl/phase1`; //ปิดสัญญาเดิม
// const GET_NPL_SELL_JUDGE = `${BASE_URL_NPL}/api/v1/preview-npl/phase2`; //ขายพิพากษา
// const GET_NPL_SELL_AGREEMENT = `${BASE_URL_NPL}/api/v1/preview-npl/phase3`; //ขายทำยอม
// const GET_NPL_MOVE_IN_OLD_STOCK_CAR = `${BASE_URL_NPL}/api/v1/preview-npl/phase4`; //โอนเข้าสต็อกรถเก่า
// const GET_NPL_RECEIVE_PAYMENT = `${BASE_URL_NPL}/api/v1/preview-npl/phase6`; //รับชำระเงิน
// const GET_PENDING_SALE_CAR_IMPOUND = `${BASE_URL_NPL}/api/v1/preview-npl/phase7`; //ยึดรอขาย
// const GET_SELLING_CAR_IMPOUND = `${BASE_URL_NPL}/api/v1/preview-npl/phase8`; //ขายรถยึด
// const GET_DEBT_ANOTHER = `${BASE_URL_NPL}/api/v1/sync-npl/phase9`; //ตั้งลูกหนี้อื่น ๆ

// //sync ตาม phase
// const POST_NPL_CLOSE_OLD_CONTNO = `${BASE_URL_NPL}/api/v1/sync-npl/phase1?limit=50`; //ปิดสัญญาเดิม
// const POST_NPL_SELL_JUDGE = `${BASE_URL_NPL}/api/v1/sync-npl/phase2?limit=50`; //ขายพิพากษา
// const POST_NPL_SELL_AGREEMENT = `${BASE_URL_NPL}/api/v1/sync-npl/phase3?limit=50`; //ขายทำยอม
// const POST_NPL_MOVE_IN_OLD_STOCK_CAR = `${BASE_URL_NPL}/api/v1/sync-npl/phase4?limit=50`; //โอนเข้าสต็อกรถเก่า
// const POST_NPL_RECEIVE_PAYMENT = `${BASE_URL_NPL}/api/v1/sync-npl/phase6?limit=50`; //รับชำระเงิน
// const POST_PENDING_SALE_CAR_IMPOUND = `${BASE_URL_NPL}/api/v1/preview-npl/phase7?limit=50`; //ยึดรอขาย
// const POST_SELLING_CAR_IMPOUND = `${BASE_URL_NPL}/api/v1/preview-npl/phase8?limit=50`; //ขายรถยึด
// const POST_DEBT_ANOTHER = `${BASE_URL_NPL}/api/v1/sync-npl/phase9?limit=50`; //ตั้งลูกหนี้อื่น ๆ

// //sync ตาม phase แบบ select
// const POST_NPL_SELL_JUDGE_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase2`; //ขายพิพากษา
// const POST_NPL_SELL_AGREEMENT_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase3`; //ขายทำยอม
// const POST_NPL_MOVE_IN_OLD_STOCK_CAR_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase4`; //โอนเข้าสต็อกรถเก่า
// const POST_NPL_RECEIVE_PAYMENT_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase6`; //รับชำระเงิน
// const POST_PENDING_SALE_CAR_IMPOUND_SELECT = `${BASE_URL_NPL}/api/v1/preview-npl/phase7`; //ยึดรอขาย
// const POST_SELLING_CAR_IMPOUND_SELECT = `${BASE_URL_NPL}/api/v1/preview-npl/phase8`; //ขายรถยึด
// const POST_DEBT_ANOTHER_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase9`; //ตั้งลูกหนี้อื่น ๆ

// const GET_AMC_STOCK = `${BASE_URL_NPL}/api/v1/preview-amc/stock`; //โอนเข้าสต็อก
// const POST_AMC_STOCK_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/stock?limit=50`; //โอนเข้าสต็อก
// const POST_AMC_STOCK_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/stock`; //โอนเข้าสต็อก

// const GET_AMC_SELL = `${BASE_URL_NPL}/api/v1/preview-amc/sell`; //ขาย/ตั้งลูกหนี้
// const POST_AMC_SELL_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/sell?limit=50`; //ขาย/ตั้งลูกหนี้
// const POST_AMC_SELL_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/sell`; //ขาย/ตั้งลูกหนี้

// const GET_AMC_STOCK_TAX = `${BASE_URL_NPL}/api/v1/preview-amc/stock/tax`; //ตามลงฝังภาษี stock
// const POST_AMC_STOCK_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/stock/tax?limit=50`; //ตามลงฝังภาษี stock
// const POST_AMC_STOCK_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/stock/tax`; //ตามลงฝังภาษี stock

// const GET_AMC_STOCK_SELL = `${BASE_URL_NPL}/api/v1/preview-amc/sell/tax`; //ตามลงฝังภาษีขาย
// const POST_AMC_STOCK_SELL_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/sell/tax?limit=50`; //ตามลงฝังภาษีขาย
// const POST_AMC_STOCK_SELL_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/sell/tax`; //ตามลงฝังภาษีขาย

// //AMC รับเงิน
// const GET_AMC_DEPOSIT = `${BASE_URL_NPL}/api/v1/preview-amc/recv?limit=100`; //รับเงินมัดจำ/ดาวน์ ภายใน
// const POST_AMC_DEPOSIT_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/recv?limit=50`; //รับเงินมัดจำ/ดาวน์ ภายใน ทั้งหมด
// const POST_AMC_DEPOSIT_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/recv`; //รับเงินมัดจำ/ดาวน์ ภายใน แบบเลือก

// //ภาษี
// const GET_AMC_DEPOSIT_TAX = `${BASE_URL_NPL}/api/v1/preview-amc/recv/tax?limit=100`; //ภาษี
// const POST_AMC_DEPOSIT_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/recv/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
// const POST_AMC_DEPOSIT_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/recv/tax`; //ภาษี ภายใน แบบเลือก

// //AMC ขาย HOS ภายใน
// const GET_TO_HOUSING = `${BASE_URL_NPL}/api/v1/preview-amc/to-housing?limit=100`; //ภายใน
// const POST_TO_HOUSING_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing?limit=50`; //ภายใน ภายใน ทั้งหมด
// const POST_TO_HOUSING_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing`; //ภายใน ภายใน แบบเลือก

// //AMC ขาย HOS ภาษี
// const GET_TO_HOUSING_TAX = `${BASE_URL_NPL}/api/v1/preview-amc/to-housing/tax?limit=100`; //ภาษี
// const POST_TO_HOUSING_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
// const POST_TO_HOUSING_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing/tax`; //ภาษี ภายใน แบบ

// //HOUSING รับเงินมัดจำ/ดาวน์/ประกัน
// //รับเงินมัดจำ/ดาวน์
// const GET_HOUSING_DEPOSIT = `${BASE_URL_NPL}/api/v1/preview-housing/all/deposit?limit=100`; //รับเงินมัดจำ/ดาวน์ ภายใน
// const POST_HOUSING_DEPOSIT_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/deposit?limit=50`; //รับเงินมัดจำ/ดาวน์ ภายใน ทั้งหมด
// const POST_HOUSING_DEPOSIT_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/deposit`; //รับเงินมัดจำ/ดาวน์ ภายใน แบบเลือก
// //ภาษี
// const GET_HOUSING_DEPOSIT_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/all/deposit/tax?limit=100`; //ภาษี
// const POST_HOUSING_DEPOSIT_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/deposit/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
// const POST_HOUSING_DEPOSIT_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/deposit/tax`; //ภาษี ภายใน แบบเลือก

// //HOUSING ตั้งลูกหนี้/โอนต้นทุน
// //รับเงินมัดจำ/ดาวน์
// const GET_HOUSING_SELL = `${BASE_URL_NPL}/api/v1/preview-housing/all/sell?limit=100`; //ภายใน
// const POST_HOUSING_SELL_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/sell?limit=50`; //ภายใน ทั้งหมด
// const POST_HOUSING_SELL_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/sell`; // ภายใน แบบเลือก
// //ภาษี
// const GET_HOUSING_SELL_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/all/sell/tax?limit=100`; //ภาษี
// const POST_HOUSING_SELL_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/sell/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
// const POST_HOUSING_SELL_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/sell/tax`; //ภาษี ภายใน แบบเลือก

// //HOUSING รับชำระค่างวด
// //รับชำระค่างวด
// const GET_HOUSING_RECV = `${BASE_URL_NPL}/api/v1/preview-housing/all/recv?limit=100`; //ภายใน
// const POST_HOUSING_RECV_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/recv?limit=50`; //ภายใน ทั้งหมด
// const POST_HOUSING_RECV_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/recv`; // ภายใน แบบเลือก
// //ภาษี
// const GET_HOUSING_RECV_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/all/recv/tax?limit=100`; //ภาษี
// const POST_HOUSING_RECV_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/recv/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
// const POST_HOUSING_RECV_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/recv/tax`; //ภาษี ภายใน แบบเลือก

// //HOUSING เช่า:คืนเงินประกัน/ล่วงหน้า 7/8
// //ภายใน
// const GET_HOUSING_LEASE_REFUND = `${BASE_URL_NPL}/api/v1/preview-housing/lease/refund?limit=100`; //ภายใน
// const POST_HOUSING_LEASE_REFUND_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/refund?limit=50`; //ภายใน ทั้งหมด
// const POST_HOUSING_LEASE_REFUND_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/refund`; // ภายใน แบบเลือก

// //ภาษี
// const GET_HOUSING_LEASE_REFUND_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/lease/refund/tax?limit=100`; //ภาษี
// const POST_HOUSING_LEASE_REFUND_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/refund/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
// const POST_HOUSING_LEASE_REFUND_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/refund/tax`; //ภาษี ภายใน แบบเลือก

// //HOUSING เช่า:เลิกเช่า/แปลงซื้อ 9/10
// //ภายใน
// const GET_HOUSING_LEASE_CLOSE = `${BASE_URL_NPL}/api/v1/preview-housing/lease/close?limit=100`; //ภายใน
// const POST_HOUSING_LEASE_CLOSE_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/close?limit=50`; //ภายใน ทั้งหมด
// const POST_HOUSING_LEASE_CLOSE_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/close`; // ภายใน แบบเลือก

// //ภาษี
// const GET_HOUSING_LEASE_CLOSE_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/lease/close/tax?limit=100`; //ภาษี
// const POST_HOUSING_LEASE_CLOSE_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/close/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
// const POST_HOUSING_LEASE_CLOSE_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/close/tax`; //ภาษี ภายใน แบบเลือก

// //HOUSING เช่า:ลูกหนี้อื่น/รับเงิน 11/12
// //ภายใน
// const GET_HOUSING_LEASE_OTHER = `${BASE_URL_NPL}/api/v1/preview-housing/lease/other?limit=100`; //ภายใน
// const POST_HOUSING_LEASE_OTHER_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/other?limit=50`; //ภายใน ทั้งหมด
// const POST_HOUSING_LEASE_OTHER_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/other`; // ภายใน แบบเลือก

// //ภาษี
// const GET_HOUSING_LEASE_OTHER_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/lease/other/tax?limit=100`; //ภาษี
// const POST_HOUSING_LEASE_OTHER_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/other/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
// const POST_HOUSING_LEASE_OTHER_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/other/tax`; //ภาษี ภายใน แบบเลือก

// //AMC ขายภาษี
// const GET_AMC_TAX = `${BASE_URL_NPL}/api/v1/preview-amc/to-housing/amc-tax?limit=100`;
// const POST_AMC_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing/amc-tax?limit=50`;
// const POST_AMC_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing/amc-tax`;

// //report
// const GET_NPL_REPORT = `${BASE_URL_NPL}/api/v1/export-excel`; //รายงาน

// //ตัดจ่าย 1,8
// const POST_MAIN_CUT_PAY_FN = `${BASE_URL_BEN}/api-new/main-jugde-fn`;
// const POST_CONFIRM_CLOSE_CONTNO = `${BASE_URL_BEN}/api-new/confirm-close-contno`;
// //กดยึด
// const POST_DEBTS_LAWYER_EFF = `${BASE_URL_BEN_NIKKI}/api-lawyer/debts-lawyer-eff`;

// //แม่ทมตั้มเบิกสืบทรัพย์
// const POST_MAIN_DTR_PAYMENT = `${BASE_URL_BEN}/api-new/load-inves-expenses`;
// const POST_CREATE_PAYMENT_INVESTIGATE = `${BASE_URL_BEN}/api-new/insert-dtr-payment`;
// const POST_LOAD_DTR_PAYMENT = `${BASE_URL_BEN}/api-new/load-dtr-payment`;
// const POST_EIDT_DTR_PAYMENT = `${BASE_URL_BEN}/api-new/update-money-online`;
// const POST_SYNC_DTR_PAYMENT = `${BASE_URL_BEN}/api-new/sync-inves-online`;

// //dashbord ดูงานทนาย
// const POST_LAWYER_JOB = `${BASE_URL_BEN}/api-new/load-loan-list`;
// // //ข้อมูล user
// const GET_USER_NEW = `${BASE_URL_BEN}/api-new/load-all-user`;

// //รายงานรับรู้กำไร
// const GET_CONFIG_INTEREST = `/api/config`;
// const GET_PROFIT_REPORT = `/api/report/profit?`;
// const GET_PROFIT_EXPORT = `/api/report/profit/export?`;
// const GET_CONFIG_INTEREST_DEV = `https://calculat-interest-i67f6gaaqa-eu.a.run.app/api/config`;
// const GET_PROFIT_REPORT_DEV = `https://calculat-interest-i67f6gaaqa-eu.a.run.app/api/report/profit?`;
// const GET_PROFIT_EXPORT_DEV = `https://calculat-interest-i67f6gaaqa-eu.a.run.app/api/report/profit/export?`;

// //คำนวน IRR รายสัญญา
// const GET_PROFIT_BY_CONTNO = `/api/loan/`;
// const POST_CALUATE_CONTNO = `/api/calculate-contract`;
// const GET_CALUATE_HISTORY = `/api/calculations/`;
// const GET_INSTALLMENTS = `/api/installments/`;
// //คำนวนมือ
// const POST_CALCULATE_SOD = `/api/sod`;
// const POST_CALCULATE_WEIGHTED = `/api/weighted`;
// const POST_CALCULATE_IRR = `/api/irr`;

// //โยกงานทนาย
// const POST_MAIN_CHANGE_JOBS = `${BASE_URL_BEN}/api-new/main-change-jobs`;
// const POST_UPDATE_CHANGE_JOBS = `${BASE_URL_BEN}/api-new/update-change-jobs`;

// //เพิ่มลูกหนี้อื่น ๆ
// const GET_LOAD_PAYFORS = `${BASE_URL_BEN}/api-new/load-pay-fors`;
// const POST_UPDATE_PAYFORS = `${BASE_URL_BEN}/api-new/create-pay-fors`;

// //รายงานรถยึด
// const POST_REPORT_IMPOUND = `${BASE_URL_BEN}/auth/report-impound`;

// //ขายรถยึด ธุรการ
// const POST_MAIN_SELLING_CAR_IMPOUND = `${BASE_URL_BEN}/auth/load-main-impound`;
// const POST_DETAIL_SELLING_CAR_IMPOUND = `${BASE_URL_BEN}/auth/load-detail-impound`;
// const POST_CONFIRM_SELLING_CAR_IMPOUND = `${BASE_URL_BEN}/auth/confirm-sale-impound`;

// //รานงานพี่ผึ้ง
// const POST_REPORT_MANAGER_ACC = `${BASE_URL_BEN}/auth/report-payment-acc-daily`;

// //คืนงานทนาย
// const POST_ROLLBACK_JOBS_LAWYERS = `${BASE_URL_BEN}/api-new/update-return-work`;

// //mongo ตรวจใบเสร็จ
// const POST_DATA_CHECK_SALE_IMPOUND =
//   "https://api-mongo-lawyer-539174983798.asia-southeast1.run.app/mongo-lawyer/log-sale-impound-dev";
// //ธุรการ เช็คเสร็จ
// const POST_CHECK_DOC_IMPOUND = `${BASE_URL_BEN}/auth/check-doc-impound`;
// //ข้อมูลเมื่อตรวจเสร็จ
// const POST_LOAD_BILL_SALE_IMPOUND =
//   "https://api-mongo-lawyer-539174983798.asia-southeast1.run.app/mongo-lawyer/get-log-sale-impound-dev";
// //การเงิน
// const POST_MAIN_SALE_IMPOUND = `${BASE_URL_BEN}/auth/main-sale-impound`;
// //การเงินกดรับเงิน
// const POST_SALE_IMPOUND = `${BASE_URL_BEN}/auth/sale-impound`;

// const GET_STATUS_THAIPOST = `${BASE_URL_BEN}/api-new/load-thaipost-status`;
// const GET_DATA_EMS =
//   "https://api-area-investigation-1024031113167.asia-southeast1.run.app/api-inv/check-contno/";

// const POST_LOST_CONTACT_DEBTS = `${BASE_URL_BEN}/api-new/load-lost-contact-debts`; //ดูข้อมูลค้างงวด
// const POST_APPROVED_DUE = `${BASE_URL_BEN}/api-new/create-due-judge`; //ขออนุมัติผ่อนจ่าย (พิพากษา จ่าย 10%)

// const POST_JUDGE_BEEYPUP = `${BASE_URL_BEN}/api-new/preview-judge-beeypup`; //โหลด เบี้ยปรับทำยอม
// const POST_LOAD_DATA_DUEPAYMENT_JUDGE = `${BASE_URL_BEN}/api-new/load-data-duepayment-judge`; //โหลด พิพากษา ตารางดิว

// //โหลด พิพากษาปกติ
// const POST_LOAD_LOST_CONTACT_JUDGE = `${BASE_URL_BEN}/api-new/load-lost-contact-judge`;

// const POST_SEARCH_CONTRACT_LAWYER = `${BASE_URL_BEN}/auth/search-contract-lawyer`; //หารายละเอียดสัญญาตาม ชื่อ-เลขบัตร
// const POST_SEARCH_CONTRACT_REGNO = `${BASE_URL_BEN_NIKKI}/api-lawyer/search-contract-by-regno`; //หารายละเอียดสัญญาตาม ทะเบียนรถ

// const API_ZACK_APL = `https://api-zack-amc-539174983798.asia-southeast1.run.app`;
// // const mainlawyer = `${API_ZACK_APL}/api-amc/main-lawyer`; // main
// const mainlawyer = `https://shark-app-j9jc9.ondigitalocean.app/debtor/customers/lawsuit-status`; // main
// const searchcontracts = `https://apl-backend-1024031113167.asia-southeast1.run.app/api/contracts/search?q=`;
// const contractDetail = `${API_ZACK_APL}/auth-amc/contract-detail-borr-code`;
// const login_amc = `https://login-api-1024031113167.asia-southeast1.run.app/login-mongo`; // login
// const SEND_NOTE_AMC = `${API_ZACK_APL}/api-amc/insert-stock-note`;

// const POST_MAIN_LOST_PRE_ENFORCEMENT = `${BASE_URL_BEN}/api-new/pre-enforcement`;
// const POST_SEND_PRE_ENFORCEMENT = `${BASE_URL_BEN}/api-new/send-enforcement`;
// const POST_LIST_ENFORCEMENT = `${BASE_URL_BEN}/api-new/list-enforcement`;

// const POST_LOAD_JUDGE_ASSET = `${BASE_URL_BEN}/api-new/load-judge-asset`;

// const POST_SEND_ENFORCEMENT = `${BASE_URL_BEN}/api-new/quick-enforcement`;
// const POST_MAIN_ENFORCEMENT = `${BASE_URL_BEN}/api-new/list-enforce-assigned`;

// const POST_CHANNGE_JOBS_ENFORCE = `${BASE_URL_BEN}/api-new/change-jobs-enforce`; //เปลี่ยนผู้สืบทรัพย์
// const POST_RECEIVE_JOBS_ENFORCE = `${BASE_URL_BEN}/api-new/receive-enforcement`; //รับงาน

// const POST_MAIN_ENFORCE_LAWYER = `${BASE_URL_BEN}/api-new/list-enforce-lawyer`; //ทนายออกหมายบังคับ
// const POST_UPDATE_ENFORCE_DOC = `${BASE_URL_BEN}/api-new/update-enforce-lawyer-doc`; //ทนายส่งสถานะออกหมายบังคับ

// const POST_UPDATE_CUSTOMER = `${BASE_URL_BEN_NIKKI}/api-lawyer/updates-customer-contact`; //อัพเดทข้อมูลลูกค้า
// const GET_GEO_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/aumphur-province`; //ดึงจังหวัด,อำเภอ คุณสาธิต

// const POST_SEARCH_OLD_CONTNO = `${BASE_URL_BEN}/api-new/load-list-tno`; //หาสัญญาเก่าจากโปรแกรมคุณสาธิต
// const POST_WARP_SEND_LAWSUIT = `${BASE_URL_BEN}/api-new/warp-lawsuit`; //วาร์ปส่งฟ้องไม่ต้องมี loan id

// const POST_CAR_IMPOUND_TNOTEFL = `https://api-car-impound-539174983798.asia-southeast1.run.app/api-carimpound/TNOTEFL`; //ดึงข้อมูลงานติดตามมีเลขบิล
// const POST_CAR_IMPOUND_SUMNOTEFL = `https://api-car-impound-539174983798.asia-southeast1.run.app/api-carimpound/SUMNOTEFL`; //ใบปิดงาน

// const POST_MAIN_REFINACE_ENFORCE = `${BASE_URL_BEN}/api-new/main-rejudge`; //รีไฟแนนซ์ พิพากษา
// const POST_DETAIL_REFINACE_ENFORCE = `${BASE_URL_BEN}/api-new/load-rejudge`; //รีไฟแนนซ์ พิพากษา
// const POST_INSERT_REJUDGE_REQUEST = `${BASE_URL_BEN}/api-new/insert-rejudge-request`; //รีไฟแนนซ์ พิพากษา
// const POST_NEW_JUDGEMENT = `${BASE_URL_BEN}/api-new/lawsult-rejudge-admin`; //รีไฟแนนซ์ พิพากษา

// const mainlawyer_V2 = `${API_ZACK_APL}/api-amc/main-lawyer`;
// const POST_LOAD_REJUDGE = `${BASE_URL_BEN}/auth/load-detail-rejudge`; //ดูรายละเอียดสัญญาเก่าที่ถูกรีไฟแนนซ์

// const POST_INSERT_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/insert-field-collection`;
// const POST_LIST_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/list-field-collection`;
// const POST_CLOSE_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/close-field-collection`; //ปิดงาน
// const POST_INSERT_FIELD_COLLECTION_NOTE = `${BASE_URL_BEN}/api-new/insert-field-collection-note`; //สร้าง note
// const POST_LIST_FIELD_COLLECTION_NOTE = `${BASE_URL_BEN}/api-new/list-field-collection-note`; //ดึงข้อมูล note
// const POST_FLAG_DOC_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/flag-doc-field-collection`; //ส่งข้อมูลเอกสาร
// const POST_ACCEPT_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/accept-field-collection`; //ชุดนอกรับงาน

// const POST_LOAD_RESUE_JUDGE = `${BASE_URL_BEN}/api-new/load-resue-judge`; //ค้นหาสัญญา
// const POST_INSERT_RESUE_JUDGE = `${BASE_URL_BEN}/api-new/insert-resue-judge`; //สร้างฟ้องใหม่

// const POST_LAWYER_STOCK = `${BASE_URL_BEN}/auth/report-lawyer-stocks`; //สร้างฟ้องใหม่
// const POST_INVENTORY_STOCK = `${BASE_URL_BEN}/auth/report-lawyer-stocks-remaining`; //รายงานสินค้าคงเหลือ

// const POST_ADD_OTHER_WORK_JUDGE = `${BASE_URL_BEN}/api-new/add-other-work-judge`; //เพิ่มลูกหนี้อื่น ๆเพิ่มเติม

// const POST_LAWYER_JOB_RECEIV = `${BASE_URL_BEN}/api-new/report-case-list`; //รายงานงานทนายพร้อมรับชำระ

// const POST_CAL_LOAN_CAR = `${BASE_URL_BEN_NIKKI}/api-lawyer/calc-loan`;

// const VERSION = "Version_Dev.1.24.1";

// export {
//   PUT_INVESTIGATE_ITEM_BY_ID,
//   POST_INVESTIGATE_ITEM,
//   GET_LAND_DETAIL_LIST,
//   GET_INVESTIGATE_LOANS_LIST,
//   PUT_USER_UPDATE,
//   HEADERS_LOGIN,
//   GET_LOAN_FROM_SERVER_IBM,
//   GET_ALL_LOAN,
//   GET_LOAN_BY_CONTNO,
//   GET_LAWYERS_LIST,
//   GET_JOB_COUNT,
//   GET_JOB_IN_PROGRESS,
//   GET_JOB_IN_PROGRESS_BY_STATUS,
//   POST_LOAN_IN_LAWYERS_DB,
//   POST_STATUS,
//   PUT_STATUS,
//   HEADERS_EXPORT,
//   baseUrl,
//   GET_LAWSUIT_DETAIL_BY_LOAN,
//   PUT_LAWSUIT_DETAIL,
//   GET_INVESTIGATE_BY_LAWSUIT,
//   GET_INVESTIGATE_LIST,
//   POST_INVESTIGATE_LOG,
//   PUT_INVESTIGATE_LOG,
//   LOG_IN,
//   REGISTER,
//   GET_WORK_LOG_DETAIL_BY_ID,
//   POST_JUDGE,
//   PUT_JUDGE,
//   GET_JUDGE_BY_ID,
//   GET_JUDGE_LIST,
//   POST_JUDGE_DEFENDANTS,
//   PUT_JUDGE_DEFENDANTS,
//   GET_JUDGE_DEFENDANTS_BY_ID,
//   GET_COMPANIES_LIST,
//   POST_AGREEMENTS,
//   PUT_AGREEMENTS,
//   GET_AGREEMENTS_BY_ID,
//   GET_LAWSUIT_DETAIL_BY_ID,
//   GET_LAWSUIT_LIST,
//   GET_ROLE_LIST,
//   GET_USERS_LIST,
//   GET_BY_ID,
//   POST_USER,
//   GET_PROVICE,
//   GET_DISTRICT,
//   GET_SUB_DISTRICT,
//   GET_ZIPCODE,
//   GET_DETAILS,
//   GET_PROVICE_LAND,
//   POST_DISTRICT_LAND,
//   POST_CALCULATE_LAND,
//   POST_PARCELS,
//   PUT_PARCELS,
//   GET_PARCELS,
//   POST_TERMINATE_CONTRACT,
//   POST_TERMINATE_CONTRACT_RECORD,
//   POST_TERMINATE_BY_CONTRACT,
//   POST_CANCEL,
//   PUT_CANCEL,
//   GET_CANCEL,
//   POST_EXPENSES,
//   PUT_EXPENSES,
//   GET_EXPENSES_LIST,
//   GET_EXPENSES_LOAN_ID,
//   GET_EXPENSES_CONTNO,
//   POST_DELETE_ID,
//   GET_EXPENSES_CONTNO_LIST,
//   GET_EXPENSE_REF_GROUP,
//   POST_LOAN_DB2,
//   POST_DETAIL_PAYMENT,
//   GET_EXPENSE_TYPE_LIST,
//   GET_SELL_STATUS,
//   POST_EXECUTE_CASE,
//   PUT_EXECUTE_CASE,
//   GET_EXECUTE_CASE,
//   DELETE_WORKLOG,
//   DELETE_CANCEL_CONTRACTS,
//   DELETE_PARCELS,
//   DELETE_AGREEMENTS,
//   DELETE_JUDGEMENTS,
//   DELETE_JUDGEMENT_DEFENDANTS,
//   DELETE_INVESTIGATE_PROPERTIES,
//   DELETE_EXPENSES,
//   POST_EXPENSES_REFERENCE,
//   PUT_EXPENSES_REFERENCE,
//   GET_EXPENSES_REFERENCE,
//   POST_DETAIL_PAYMENT_LEASING,
//   GET_PROVICE_DB,
//   POST_DISTRICT_DB,
//   POST_SUB_DISTRICT_DB,
//   POST_PRE_INVESTIGATE_CHECK,
//   POST_RECEIVE_PAYMENT,
//   PUT_RECEIVE_PAYMENT,
//   GET_RECEIVE_PAYMENT,
//   GET_RECEIVE_PAYMENT_BY_PARAMS,
//   DELETE_RECEIVE_PAYMENT_BY_ID,
//   POST_PRE_INVESTIGATE_LOG,
//   POST_PRE_INVESTIGATE_REPORT,
//   POST_LOAD_MEMO,
//   HEADERS_EXPORT_BEN,
//   POST_LITIGATION_FUNDS,
//   BASE_URL_BEN,
//   POST_CANCEL_LIST,
//   POST_NEW_LOAN,
//   POST_UPDATE_PARCEL,
//   GET_SELECT_RE_PRINT,
//   POST_DATA_RE_PRINT,
//   POST_UPDATE_PARCEL_STATUS,
//   POST_LOAD_BY_DATE,
//   POST_LOAD_BY_QUERY,
//   BASE_URL_BEN_NIKKI,
//   POST_PRE_INVESTIGATE,
//   POST_CANCEL_HAND_PRE,
//   POST_PRE_INVESTIGATE_CANCEL_HAND,
//   POST_CHECK_JOB_CANCEL_HAND,
//   POST_CHECK_JOB_DETIAL_CANCEL_HAND,
//   GET_CHECK_JOB_CANCEL_ROUND,
//   PUT_STATUS_ROUND,
//   POST_CHECK_PRE_WCC,
//   POST_LOAN_DB2_V2,
//   POST_CANCEL_HAND,
//   PUT_STATUS_SEND,
//   POST_LOAD_WCC_DAY,
//   POST_CHECK_ADD_CANCEL_HAND,
//   POST_MAIN_INVESTIGATE_ONLINE,
//   POST_LIST_INVESTIGATE_ONLINE,
//   PUT_STATUS_INVESTIGATE_ONLINE,
//   GET_LIST_CANCEL_HAND_DATE,
//   GET_LIST_INVESTIGATE_ONLINE,
//   POST_LOAD_MAIN_INVESTIGATION,
//   POST_ADD_ASSETTHASLOAN,
//   GET_ADD_COORDINATES,
//   POST_ADD_ASSET,
//   POST_EDIT_ASSET,
//   POST_UPLOAD_IMAGE,
//   GET_LOAD_IMAGE,
//   DELETE_ASSETLANDAREA,
//   DELETE_ASSET,
//   DELETE_IMAGE,
//   POST_LOAD_ASSET,
//   POST_LOAD_MAIN_ASSET,
//   EDIT_CUSTOMER_ASSET,
//   DELETE_CUSTOMER_ALL_ASSET,
//   DELETE_CUSTOMER_ONE_ASSET,
//   DELETE_IMAGE_NOT_ASSET,
//   GET_GEO_ALL,
//   POST_SEND_RESPONE_INVESTIGATE,
//   POST_LIST_ASSET,
//   POST_MAIN_ASSET_BY_DATE,
//   POST_MAIN_ASSET_BY_CONTNO,
//   POST_MAIN_ASSET_BY_STATUS,
//   POST_UPDATE_EXCEL_MEMO,
//   POST_UPDATE_MEMO,
//   POST_LAWSUIT_DETAIL,
//   POST_NOTIC_LAWSUIT,
//   POST_CHECK_DOC,
//   POST_ACCEPT_WORK,
//   POST_ADD_ADDRESS_TR,
//   POST_DOC_STATUS,
//   POST_MAIN_LAWYER,
//   POST_ACCEPT_LAWYER,
//   POST_MAIN_WITHDRAW,
//   POST_EXPENSE_LIST,
//   POST_UPDATE_BILL,
//   POST_DOC_RESEND,
//   POST_CREATE_LAWSUIT,
//   POST_BACK_CASE_NUMBER,
//   POST_UPDATE_EXPENSE,
//   POST_MAIN_ADVANCE_PAY,
//   POST_BILL_DETAIL,
//   POST_APPROVALADVANE_PAY,
//   POST_MAIN_PAYMENT,
//   POST_CLEAR_PAYMENT,
//   POST_CLEAR_APPROVAL,
//   POST_ACCEPT_DOC,
//   POST_DOC_SUCCESS,
//   POST_CHECK_BILL,
//   POST_LOAD_GURANTOR,
//   POST_STATUS_JUDGMENT,
//   POST_ADD_DEFENDANT,
//   POST_UPDATE_ENFORCE_CASE_DATE,
//   POST_UPDATE_FINAL_CASE_DATE,
//   POST_UPLOAD_IMAGE_NEW,
//   GET_LOAD_IMAGE_NEW_ALL,
//   GET_LOAD_IMAGE_NEW_BY,
//   POST_DELETE_IMAGE_NEW,
//   HEADERS_UPIMAGE,
//   POST_LOAD_MEMO_NEW,
//   POST_CONTNO_DETAIL,
//   POST_CALCULATE_CONTNO_NEW,
//   HEADERS_EXPORT_DETAIL,
//   POST_CONTNO_DETAIL_SEARCH,
//   GET_MAIN_OLD_DATA,
//   POST_LOAD_DETAIL_OLD_DATA,
//   POST_UPDATE_JUDGE,
//   POST_BILL_PAYMENT,
//   VERSION,
//   POST_MAIN_RECHECK_JUDGE_DOC,
//   POST_JUDGE_DOC_DETAIL,
//   POST_ACCEPT_RECHECK_JUDGE_DOC,
//   POST_RECHECK_COMPLETE_JUDGE_DOC,
//   POST_ACCEPT_CEO_RECHECK_JUDGE_DOC,
//   POST_CEO_RECHECK_COMPLETE_JUDGE_DOC,
//   POST_REPORT_PAYMENT_DAILY,
//   POST_REPORT_AROTHR_DAILY,
//   POST_PRINT_FLAG,
//   POST_REPORT_INVES,
//   GET_LOAD_BANK,
//   POST_ADVANE_PAY_DB2,
//   POST_PRINT_ADVANCE_PAY_DB2,
//   POST_CLEAR_PAYMENT_DB2,
//   POST_PRINT_CLEAR_PAYMENT_DB2,
//   POST_REPORT_DAILY_ADVANCE_PAY_DB2,
//   POST_REPORT_DAILY_ADVANCE_CLEAR_PAY_DB2,
//   POST_INSERT_NOTE_NEW,
//   GET_COMPANIES_LIST_NEW,
//   POST_ROUND_AGREEMENT,
//   POST_EMS_AGREEMENT,
//   POST_ACCEPT_ACC_RECHECK_JUDGE_DOC,
//   POST_COMPLETE_ACC_RECHECK_JUDGE_DOC,
//   POST_RESEND_COMPLETE_JUDGE_DOC,
//   HEADERS_NPL,
//   BASE_URL_NPL,
//   GET_NPL_CLOSE_OLD_CONTNO,
//   GET_NPL_SELL_JUDGE,
//   GET_NPL_SELL_AGREEMENT,
//   GET_NPL_MOVE_IN_OLD_STOCK_CAR,
//   GET_NPL_RECEIVE_PAYMENT,
//   POST_NPL_CLOSE_OLD_CONTNO,
//   POST_NPL_SELL_JUDGE,
//   POST_NPL_SELL_AGREEMENT,
//   POST_NPL_MOVE_IN_OLD_STOCK_CAR,
//   POST_NPL_RECEIVE_PAYMENT,
//   GET_NPL_REPORT,
//   POST_MAIN_CUT_PAY_FN,
//   POST_CONFIRM_CLOSE_CONTNO,
//   POST_DEBTS_LAWYER_EFF,
//   POST_APPEAL_LAWYER,
//   POST_REPORT_SELLING,
//   POST_REPORT_SELLING_AND_INSTALLMENTS,
//   BASE_URL_IMAGE,
//   POST_CREATE_PAYMENT_INVESTIGATE,
//   POST_LOAD_DTR_PAYMENT,
//   POST_EIDT_DTR_PAYMENT,
//   POST_SYNC_DTR_PAYMENT,
//   POST_REPORT_DEBIT_BALANCE,
//   POST_LAWYER_JOB,
//   GET_USER_NEW,
//   POST_MAIN_DTR_PAYMENT,
//   GET_CONFIG_INTEREST,
//   GET_PROFIT_REPORT,
//   GET_PROFIT_EXPORT,
//   GET_PROFIT_BY_CONTNO,
//   POST_CALUATE_CONTNO,
//   GET_CALUATE_HISTORY,
//   GET_INSTALLMENTS,
//   POST_CALCULATE_SOD,
//   POST_CALCULATE_WEIGHTED,
//   POST_CALCULATE_IRR,
//   GET_CONFIG_INTEREST_DEV,
//   GET_PROFIT_REPORT_DEV,
//   GET_PROFIT_EXPORT_DEV,
//   POST_MAIN_CHANGE_JOBS,
//   POST_UPDATE_CHANGE_JOBS,
//   POST_LOAD_DATA_DUEPAYMENT,
//   POST_PREVIEW_BEEYPUP,
//   POST_PREVIEW_JUDGE,
//   POST_FOLLOW_CUSTOMER,
//   GET_LOAD_PAYFORS,
//   POST_UPDATE_PAYFORS,
//   POST_REPORT_IMPOUND,
//   POST_MAIN_SELLING_CAR_IMPOUND,
//   POST_DETAIL_SELLING_CAR_IMPOUND,
//   POST_CONFIRM_SELLING_CAR_IMPOUND,
//   POST_CHECK_HD_PAYMENT,
//   POST_REPORT_MANAGER_ACC,
//   POST_ROLLBACK_JOBS_LAWYERS,
//   POST_DATA_CHECK_SALE_IMPOUND,
//   POST_LOAD_BILL_SALE_IMPOUND,
//   POST_CHECK_DOC_IMPOUND,
//   POST_MAIN_SALE_IMPOUND,
//   POST_SALE_IMPOUND,
//   GET_PENDING_SALE_CAR_IMPOUND,
//   GET_SELLING_CAR_IMPOUND,
//   POST_PENDING_SALE_CAR_IMPOUND,
//   POST_SELLING_CAR_IMPOUND,
//   GET_STATUS_THAIPOST,
//   GET_DATA_EMS,
//   POST_REPORT_SUMMARY_PAYMENT,
//   POST_CONTNO_PAYMENT_DAILY,
//   POST_LOST_CONTACT_DEBTS,
//   POST_APPROVED_DUE,
//   POST_JUDGE_BEEYPUP,
//   POST_LOAD_DATA_DUEPAYMENT_JUDGE,
//   POST_LOAD_LOST_CONTACT_JUDGE,
//   POST_SEARCH_CONTRACT_LAWYER,
//   GET_DEBT_ANOTHER,
//   POST_DEBT_ANOTHER,
//   POST_NPL_SELL_JUDGE_SELECT,
//   POST_NPL_SELL_AGREEMENT_SELECT,
//   POST_NPL_MOVE_IN_OLD_STOCK_CAR_SELECT,
//   POST_NPL_RECEIVE_PAYMENT_SELECT,
//   POST_PENDING_SALE_CAR_IMPOUND_SELECT,
//   POST_SELLING_CAR_IMPOUND_SELECT,
//   POST_DEBT_ANOTHER_SELECT,
//   GET_AMC_STOCK,
//   GET_AMC_SELL,
//   GET_AMC_STOCK_TAX,
//   GET_AMC_STOCK_SELL,
//   POST_AMC_STOCK_ALL,
//   POST_AMC_SELL_ALL,
//   POST_AMC_STOCK_TAX_ALL,
//   POST_AMC_STOCK_SELL_ALL,
//   POST_AMC_STOCK_SELECT,
//   POST_AMC_SELL_SELECT,
//   POST_AMC_STOCK_TAX_SELECT,
//   POST_AMC_STOCK_SELL_SELECT,
//   API_ZACK_APL,
//   mainlawyer,
//   searchcontracts,
//   contractDetail,
//   login_amc,
//   POST_MAIN_LOST_PRE_ENFORCEMENT,
//   POST_SEND_PRE_ENFORCEMENT,
//   POST_LIST_ENFORCEMENT,
//   POST_LOAD_JUDGE_ASSET,
//   POST_SEARCH_CONTRACT_REGNO,
//   POST_SEND_ENFORCEMENT,
//   POST_MAIN_ENFORCEMENT,
//   SEND_NOTE_AMC,
//   GET_HOUSING_DEPOSIT,
//   POST_HOUSING_DEPOSIT_ALL,
//   POST_HOUSING_DEPOSIT_SELECT,
//   GET_HOUSING_DEPOSIT_TAX,
//   POST_HOUSING_DEPOSIT_TAX_ALL,
//   POST_HOUSING_DEPOSIT_TAX_SELECT,
//   GET_HOUSING_SELL,
//   GET_HOUSING_SELL_TAX,
//   POST_HOUSING_SELL_ALL,
//   POST_HOUSING_SELL_SELECT,
//   POST_HOUSING_SELL_TAX_ALL,
//   POST_HOUSING_SELL_TAX_SELECT,
//   GET_HOUSING_RECV,
//   GET_HOUSING_RECV_TAX,
//   POST_HOUSING_RECV_ALL,
//   POST_HOUSING_RECV_SELECT,
//   POST_HOUSING_RECV_TAX_ALL,
//   POST_HOUSING_RECV_TAX_SELECT,
//   GET_AMC_DEPOSIT,
//   POST_AMC_DEPOSIT_ALL,
//   POST_AMC_DEPOSIT_SELECT,
//   GET_AMC_DEPOSIT_TAX,
//   POST_AMC_DEPOSIT_TAX_ALL,
//   POST_AMC_DEPOSIT_TAX_SELECT,
//   POST_CHANNGE_JOBS_ENFORCE,
//   POST_RECEIVE_JOBS_ENFORCE,
//   POST_MAIN_ENFORCE_LAWYER,
//   POST_UPDATE_ENFORCE_DOC,
//   POST_UPDATE_CUSTOMER,
//   GET_GEO_DB2,
//   POST_SEARCH_OLD_CONTNO,
//   POST_WARP_SEND_LAWSUIT,
//   POST_CAR_IMPOUND_TNOTEFL,
//   POST_CAR_IMPOUND_SUMNOTEFL,
//   POST_MAIN_REFINACE_ENFORCE,
//   POST_DETAIL_REFINACE_ENFORCE,
//   POST_NEW_JUDGEMENT,
//   POST_INSERT_REJUDGE_REQUEST,
//   mainlawyer_V2,
//   POST_LOAD_REJUDGE,
//   POST_INSERT_FIELD_COLLECTION,
//   POST_LIST_FIELD_COLLECTION,
//   POST_CLOSE_FIELD_COLLECTION,
//   POST_INSERT_FIELD_COLLECTION_NOTE,
//   POST_LIST_FIELD_COLLECTION_NOTE,
//   POST_FLAG_DOC_FIELD_COLLECTION,
//   GET_TO_HOUSING,
//   POST_TO_HOUSING_ALL,
//   POST_TO_HOUSING_SELECT,
//   GET_TO_HOUSING_TAX,
//   POST_TO_HOUSING_TAX_ALL,
//   POST_TO_HOUSING_TAX_SELECT,
//   POST_ACCEPT_FIELD_COLLECTION,
//   POST_LOAD_RESUE_JUDGE,
//   POST_INSERT_RESUE_JUDGE,
//   POST_LAWYER_STOCK,
//   POST_INVENTORY_STOCK,
//   GET_AMC_TAX,
//   POST_AMC_TAX_ALL,
//   POST_AMC_TAX_SELECT,
//   POST_ADD_OTHER_WORK_JUDGE,
//   POST_LAWYER_JOB_RECEIV,
//   POST_CAL_LOAN_CAR,
//   GET_HOUSING_LEASE_REFUND,
//   POST_HOUSING_LEASE_REFUND_ALL,
//   POST_HOUSING_LEASE_REFUND_SELECT,
//   GET_HOUSING_LEASE_REFUND_TAX,
//   POST_HOUSING_LEASE_REFUND_TAX_ALL,
//   POST_HOUSING_LEASE_REFUND_TAX_SELECT,
//   GET_HOUSING_LEASE_CLOSE,
//   POST_HOUSING_LEASE_CLOSE_ALL,
//   POST_HOUSING_LEASE_CLOSE_SELECT,
//   GET_HOUSING_LEASE_CLOSE_TAX,
//   POST_HOUSING_LEASE_CLOSE_TAX_ALL,
//   POST_HOUSING_LEASE_CLOSE_TAX_SELECT,
//   GET_HOUSING_LEASE_OTHER,
//   POST_HOUSING_LEASE_OTHER_ALL,
//   POST_HOUSING_LEASE_OTHER_SELECT,
//   GET_HOUSING_LEASE_OTHER_TAX,
//   POST_HOUSING_LEASE_OTHER_TAX_ALL,
//   POST_HOUSING_LEASE_OTHER_TAX_SELECT,
// };

// ----production-----
// const baseUrl = "https://shark-app-j9jc9.ondigitalocean.app";
const baseUrl = "https://assessmentsapi-317162740896.asia-southeast3.run.app";

const TOKEN = localStorage.getItem("TOKEN");
const HEADERS_EXPORT = {
  "x-access-token": TOKEN,
};

const HEADERS_EXPORT_DETAIL = {
  Authorization: TOKEN,
};

const HEADERS_EXPORT_BEN = {
  "Content-Type": "application/json",
  Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
};

const HEADERS_LOGIN = {
  "Content-Type": "application/json",
};

const BASE_URL_BEN =
  "https://api-asset-investigation-1024031113167.asia-southeast1.run.app";
const BASE_URL_BEN_NIKKI = `https://api-nikki-1024031113167.asia-southeast1.run.app`;

// //ดึง users ในระบบ
const GET_LAWYERS_LIST = "/lawyer/api/users";
const GET_COMPANIES_LIST = "/lawyer/api/companies";
const GET_COMPANIES_LIST_NEW = `/api-new/find-company`;
const GET_ROLE_LIST = "/lawyer/api/roles";
const GET_USERS_LIST = "/lawyer/api/users";
const GET_BY_ID = "/lawyer/api/users/";
const GET_SELL_STATUS = "/lawyer/api/sale-status";

//post
const LOG_IN = `/lawyer/api/login`;
const REGISTER = `/lawyer/api/register`;
const POST_USER = `/lawyer/api/users`;
const PUT_USER_UPDATE = `/lawyer/api/customers`;

//เคลียร์เงินระบบบังคับคดี (ระบบเก่า)
const GET_EXPENSES_LIST = `/lawyer/api/expenses`;
const PUT_EXPENSES = `/lawyer/api/expenses/`;
const PUT_EXPENSES_REFERENCE = `/lawyer/api/expenses-reference`;
const GET_LAWSUIT_LIST = `/lawyer/api/lawsuits`;
const GET_JOB_COUNT = "/lawyer/api/loans/notics/count";

//get ข้อมูลบอกเลิกสัญญาเบน (ไม่ใช้แล้ว)
const POST_TERMINATE_CONTRACT = `${BASE_URL_BEN_NIKKI}/api-lawyer/nikki`;
const POST_TERMINATE_CONTRACT_RECORD = `${BASE_URL_BEN_NIKKI}/api-lawyer/nikki2-v2`;
const POST_TERMINATE_BY_CONTRACT = `${BASE_URL_BEN_NIKKI}/api-lawyer/detail-contno`;

//ค้นหาสัญญา เบน
const POST_LOAN_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/search-contno`;
const POST_LOAN_DB2_V2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/search-contno-v2`;

//ข้อมูลการผ่อน เส้น 1,3,8(ที่ดิน) การ์ดลูกหนี้
const POST_DETAIL_PAYMENT = `${BASE_URL_BEN_NIKKI}/api-lawyer/tonbalance`;

//ข้อมูลการผ่อน 8(ไม่ใช่ดิน) การ์ดลูกหนี้
const POST_DETAIL_PAYMENT_LEASING = `${BASE_URL_BEN_NIKKI}/api-lawyer/leasing`;

//หาสัญญาที่ขาดการติดต่อเพื่อส่งสืบทรัพย์ (60 ,120, 180)
const POST_PRE_INVESTIGATE_CHECK = `${BASE_URL_BEN_NIKKI}/api-lawyer/check-miss-call-`;

//memo สืบทรัพย์
const POST_LOAD_MEMO = `${BASE_URL_BEN_NIKKI}/api-lawyer/load-memo1`;
const POST_LOAD_MEMO_NEW = `${BASE_URL_BEN_NIKKI}/api-lawyer/memo1-contract`;
const POST_UPDATE_EXCEL_MEMO = `${BASE_URL_BEN_NIKKI}/api-lawyer/updates-excel-memo1`;
const POST_UPDATE_MEMO = `${BASE_URL_BEN_NIKKI}/api-lawyer/updates-memo1`;

//หาทุนทรัพย์
const POST_LITIGATION_FUNDS = `${BASE_URL_BEN_NIKKI}/api-lawyer/getleasingcase`; //เส้นจริง

//รอบของบอกเลิก
const GET_SELECT_RE_PRINT = `${BASE_URL_BEN}/api-new/select-re-print`;
//ข้อมูลรีปริ้นท์
const POST_DATA_RE_PRINT = `${BASE_URL_BEN_NIKKI}/api-lawyer/load-data-re-print`;

//api จัดการบอกเลิก
const POST_CANCEL_LIST = "/api-new/load-work-cancel-contract-new";
const POST_NEW_LOAN = "/api-new/create-wcc-new";
const POST_UPDATE_PARCEL = "/api-new/update-parcel";
const POST_UPDATE_PARCEL_STATUS = "/api-new/update-parcel-status";

//ceo เลือกสัญญา
const POST_PRE_INVESTIGATE = `/api-new/create-inv-new`; //ส่งสืบ
const POST_CANCEL_HAND_PRE = `/api-new/pre-wcc`; //บอกเลิกมือ
const POST_PRE_INVESTIGATE_CANCEL_HAND = `/api-new/mix-wcc-hand-inv`; //กดทั้งสอง

//เบลส่งสืบ
const POST_MAIN_INVESTIGATE_ONLINE = `/api-new/load-inves-round`;
const POST_LIST_INVESTIGATE_ONLINE = `/api-new/load-data-list-inves`; //get list for update & export
const PUT_STATUS_INVESTIGATE_ONLINE = `/api-new/send-inves-round`; //ส่งสถานะ 1->2
const GET_LIST_INVESTIGATE_ONLINE = `/api-new/all-inves-round`; //ข้อมูลรอบ
const POST_SEND_RESPONE_INVESTIGATE = `/api-new/enter-detail-asset`;
const POST_LIST_ASSET = `/api-new/load-list-asset`;
const POST_EDIT_ASSET = "/api-new/update-asset";
const POST_MAIN_ASSET_BY_DATE = "/api-new/load-main-asset";
const POST_MAIN_ASSET_BY_CONTNO = "/api-new/search-contno-asset";
const POST_MAIN_ASSET_BY_STATUS = "/api-new/search-status-asset";
const POST_REPORT_INVES = `/api-new/report-inves`;

//ออกบอกเลิกมือ (ไม่ใช้แล้ว)
const GET_CHECK_JOB_CANCEL_ROUND = `${BASE_URL_BEN}/api-new/select-all-round-wcc`;
const POST_CHECK_JOB_CANCEL_HAND = `${BASE_URL_BEN}/api-new/select-round-wcc`; //รอบที่จะส่ง
const POST_CHECK_JOB_DETIAL_CANCEL_HAND = `${BASE_URL_BEN}/api-new/load-wcc`; //ดึงข้อมูลออก excel
const POST_CHECK_PRE_WCC = `${BASE_URL_BEN}/api-new/load-pre-wcc`; //ดึงข้อมูลออก excel
const PUT_STATUS_ROUND = `${BASE_URL_BEN}/api-new/update-response`; //อัพเดทว่าข้อมูลเลขไปรษณีย์ครบ
const POST_CANCEL_HAND = `${BASE_URL_BEN}/api-new/create-wcc-hand-new`; //ปอส่งออกบอกเลิก
const PUT_STATUS_SEND = `${BASE_URL_BEN}/api-new/update-send-pre-wcc`; //ปอส่งออกบอกเลิก
const POST_LOAD_WCC_DAY = `${BASE_URL_BEN}/api-new/load-wcc-day`; //ปอส่งออกบอกเลิก
const POST_CHECK_ADD_CANCEL_HAND = `${BASE_URL_BEN_NIKKI}/api-lawyer/check-add-contno`;
const GET_LIST_CANCEL_HAND_DATE = `${BASE_URL_BEN}/api-new/all-wcc-day`;

//ข้อมูลรอบเดือน
const POST_LOAD_BY_DATE = "/api-new/query-work-cancel-contract-new";
//ข้อมูลตาม query เลขสัญญา, เลขไปรษณีย์, ชื่อ-สกุล
const POST_LOAD_BY_QUERY = "/api-new/query-work-cancel-contract-new-2";

// ------------------------------------------------ เริ่มต้นลงพื้นที่และเพิ่มทรัพย์ ------------------------------------------------ //
// สำหรับลงวันที่ที่จะลงพื้นที่
// const POST_LOAD_MAIN_INVESTIGATION = `http://localhost:8070/api-inv/load-main-investigation`; // ดึงข้อมูลการลงพื้นที่หลัก
// const POST_ADD_ASSETTHASLOAN = `http://localhost:8070/api-inv/add-assethasloan`; // ลงวันที่ที่จะลงพื้นที่
const POST_LOAD_MAIN_INVESTIGATION = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/load-main-investigation`; // ดึงข้อมูลการลงพื้นที่หลัก
const POST_ADD_ASSETTHASLOAN = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/add-assethasloan`; // ลงวันที่ที่จะลงพื้นที่

// สำหรับลงพิกัดตาม Google Map
const GET_ADD_COORDINATES = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/add-coordinates`; // เพิ่มพิกัด

// สำหรับทรัพย์
// const POST_LOAD_ASSET = `http://localhost:8070/api-inv/load-asset`; // add asset (เพิ่มทรัพย์) type : create
// const POST_LOAD_MAIN_ASSET = `http://localhost:8070/api-inv/load-main-addasset`; // add asset (เพิ่มทรัพย์) type : create
// const POST_ADD_ASSET = `http://localhost:8070/api-inv/add-asset`; // add asset (เพิ่มทรัพย์) type : create
// const POST_EDIT_ASSET = `http://localhost:8070/api-inv/update-asset`; // edit asset (แก้ไขทรัพย์) type : update
// const DELETE_ASSET = `http://localhost:8070/api-inv/delete-asset`; // delete asset (ลบทรัพย์) แบบไม่มีทรัพย์
// const DELETE_ASSETLANDAREA = `http://localhost:8070/api-inv/delete-assetlandarea`; // delete asset (ลบทรัพย์) แบบมีทรัพย์
// const EDIT_CUSTOMER_ASSET = `http://localhost:8070/api-inv/update-ac`; // edit customer asset (แก้ไขเจ้าของทรัพย์)
// const DELETE_CUSTOMER_ALL_ASSET = `http://localhost:8070/api-inv/delete-clc`; // delete customer asset (ลบเจ้าของทรัพย์)
// const DELETE_CUSTOMER_ONE_ASSET = `http://localhost:8070/api-inv/delete-clc-one`; // delete customer asset (ลบเจ้าของทรัพย์)
const POST_LOAD_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/load-asset`; // add asset (เพิ่มทรัพย์) type : create
const POST_LOAD_MAIN_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/load-main-addasset`; // add asset (เพิ่มทรัพย์) type : create
const POST_ADD_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/add-asset`; // add asset (เพิ่มทรัพย์) type : create
const DELETE_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/delete-asset`; // delete asset (ลบทรัพย์) แบบไม่มีทรัพย์
const DELETE_ASSETLANDAREA = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/delete-assetlandarea`; // delete asset (ลบทรัพย์) แบบมีทรัพย์
const EDIT_CUSTOMER_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/update-ac`; // edit customer asset (แก้ไขเจ้าของทรัพย์)
const DELETE_CUSTOMER_ALL_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/delete-clc`; // delete customer asset (ลบเจ้าของทรัพย์)
const DELETE_CUSTOMER_ONE_ASSET = `https://api-area-investigation-539174983798.asia-southeast1.run.app/api-inv/delete-clc-one`; // delete customer asset (ลบเจ้าของทรัพย์)

// สำหรับรูปภาพ
// const POST_UPLOAD_IMAGE = `http://localhost:8090/api-lawyer/upload-image-area`; // upload image (เพิ่มรูปภาพ)
// const GET_LOAD_IMAGE = `http://localhost:8090/apimg-pdf/getImages`; // load images (โหลดรูปภาพ)
// const DELETE_IMAGE = `http://localhost:8090/api-lawyer/delete-image-area`; // delete images (ลบรูปภาพ) ทีละรูป ฝนหน้าแก้ไข
// const DELETE_IMAGE_NOT_ASSET = `http://localhost:8090/api-lawyer/delete-urlpath`; // delete images (ลบรูปภาพ) ทีละรูป ฝนหน้าแก้ไข
const POST_UPLOAD_IMAGE = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/api-lawyer/upload-image-area`; // upload image (เพิ่มรูปภาพ)
const GET_LOAD_IMAGE = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/apimg-pdf/getImages`; // load images (โหลดรูปภาพ)
const DELETE_IMAGE = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/api-lawyer/delete-image-area`; // delete images (ลบรูปภาพ)
const DELETE_IMAGE_NOT_ASSET = `https://api-uploadimage-lawyer-539174983798.asia-southeast1.run.app/api-lawyer/delete-urlpath`; // delete images (ลบรูปภาพ) ทีละรูป ฝนหน้าแก้ไข

// ------------------------------------------------ สิ้นสุดลงพื้นที่และเพิ่มทรัพย์ ------------------------------------------------ //

const GET_GEO_ALL = `${BASE_URL_BEN}/api-new/data-area`;

//ดู detail คำฟ้อง
const POST_LAWSUIT_DETAIL = `${BASE_URL_BEN}/api-new/detail-lawsult`;
const POST_NOTIC_LAWSUIT = `${BASE_URL_BEN}/api-new/lawsult`; // เฮียกดและอัพเดท
const POST_CREATE_LAWSUIT = `${BASE_URL_BEN}/api-new/lawsult-lawyer`; //ทนายสร้างคำฟ้อง
const POST_BACK_CASE_NUMBER = `${BASE_URL_BEN}/api-new/update-black-case`; //อัพเดทเลขคดีดำ
const POST_UPDATE_EXPENSE = `${BASE_URL_BEN}/api-new/updates-expense-list`; //อัพเดทยอดเงิน

//ธุรการเตรียมเอกสาร
const POST_ACCEPT_DOC = `${BASE_URL_BEN}/api-new/accept-doc-ad`;
const POST_DOC_SUCCESS = `${BASE_URL_BEN}/api-new/check-doc-ad`;

//เบลตรวจเอกสาร
const POST_CHECK_DOC = `${BASE_URL_BEN}/api-new/main-lawsult-doc`;
const POST_ACCEPT_WORK = `${BASE_URL_BEN}/api-new/accept-check-doc`;
const POST_DOC_STATUS = `${BASE_URL_BEN}/api-new/upsert-lawsult-doc`;
const POST_DOC_RESEND = `${BASE_URL_BEN}/api-new/resend-lawsult-doc`;

//เพิ่มทร.14
const POST_ADD_ADDRESS_TR = `${BASE_URL_BEN}/api-new/add-address-tr`;

//main lawyer
const POST_MAIN_LAWYER = `${BASE_URL_BEN}/api-new/main-lawsult`;
const POST_ACCEPT_LAWYER = `${BASE_URL_BEN}/api-new/accept-lawyer`;
// ทนายอุธรณ์
const POST_APPEAL_LAWYER = `${BASE_URL_BEN}/api-new/lawsult-appeal-lawyer`;

//advance payment lawsuit
const POST_MAIN_WITHDRAW = `${BASE_URL_BEN}/api-new/main-withdraw`;
const POST_EXPENSE_LIST = `${BASE_URL_BEN}/api-new/load-expense-list`;
const POST_UPDATE_BILL = `${BASE_URL_BEN}/api-new/update-bill`;
const POST_MAIN_PAYMENT = `${BASE_URL_BEN}/api-new/main-payment`;
const POST_CLEAR_PAYMENT = `${BASE_URL_BEN}/api-new/clear-payment`;
const POST_CHECK_BILL = `${BASE_URL_BEN}/api-new/check-advane-pay`;

//แม่ทม
const POST_MAIN_ADVANCE_PAY = `${BASE_URL_BEN}/api-new/main-advane-pay`;
const POST_APPROVALADVANE_PAY = `${BASE_URL_BEN}/api-new/approval-advane-pay`;
const POST_BILL_DETAIL = `${BASE_URL_BEN}/api-new/list-payment`;
const POST_CLEAR_APPROVAL = `${BASE_URL_BEN}/api-new/approval-clear-payment`;
const POST_PRINT_FLAG = `${BASE_URL_BEN}/api-new/update-flag-print`;

//พิพากษา
const POST_LOAD_GURANTOR = `${BASE_URL_BEN}/api-new/load-requisite`;
const POST_STATUS_JUDGMENT = `${BASE_URL_BEN}/api-new/work-judge`; //เลื่อนวันนัดศาล  + ถอนฟ้อง + ลงคำพิพากษา
const POST_ADD_DEFENDANT = `${BASE_URL_BEN}/api-new/add-customer-judge`; //เพิ่มจำเลย
const POST_UPDATE_ENFORCE_CASE_DATE = `${BASE_URL_BEN}/api-new/update-enforce-case-date`; //หมายตั้ง
const POST_UPDATE_FINAL_CASE_DATE = `${BASE_URL_BEN}/api-new/update-final-case-date`; ////คดีถึงที่สุด

const HEADERS_UPIMAGE = {
  Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
};
const BASE_URL_IMAGE =
  "https://api-uploadimage-lawyer-1024031113167.asia-southeast1.run.app";
// // upload img
const POST_UPLOAD_IMAGE_NEW = `${BASE_URL_IMAGE}/api-lawyer/upload-gather-image`; //upload
const GET_LOAD_IMAGE_NEW_ALL = `${BASE_URL_IMAGE}/api-lawyer/load-gather-image`; //load img
const GET_LOAD_IMAGE_NEW_BY = `${BASE_URL_IMAGE}/apimg-pdf/get-gather-image`; //แสดงรูป
const POST_DELETE_IMAGE_NEW = `${BASE_URL_IMAGE}/apimg-pdf/delete-gather-image`; //ลบรูป

//contnoDetail
const POST_CONTNO_DETAIL_SEARCH = `${BASE_URL_BEN}/auth/load-detail-new-contno`; //รายละเอียดสัญญา
const POST_CONTNO_DETAIL = `${BASE_URL_BEN}/auth/main-payment-contno`;
const POST_CALCULATE_CONTNO_NEW = `${BASE_URL_BEN}/auth/calculate-new-contno`;
// ตารางดิว
const POST_LOAD_DATA_DUEPAYMENT = `${BASE_URL_BEN}/api-new/load-data-duepayment`; /* ตารางดิว ทำยอม */
const POST_PREVIEW_BEEYPUP = `${BASE_URL_BEN}/api-new/preview-beeypup`; /* พรีวิว เบี้ยปรับ ทำยอม */
const POST_PREVIEW_JUDGE = `${BASE_URL_BEN}/api-new/preview-Judge`; /* พรีวิว ยอดจ่าย พิพากษา ปกติ */
// บันทึกติดตาม
const POST_FOLLOW_CUSTOMER = `${BASE_URL_BEN}/api-new/find-tmp-tel`;

// //โหลดข้อมูลเก่า ใบเสร็จชำระหลังฟ้อง
const GET_MAIN_OLD_DATA = `${BASE_URL_BEN}/api-new/load-main-old-data`;
const POST_LOAD_DETAIL_OLD_DATA = `${BASE_URL_BEN}/api-new/load-detail-old-data`;
const POST_UPDATE_JUDGE = `${BASE_URL_BEN}/api-new/check-old-data`;
const POST_BILL_PAYMENT = `${BASE_URL_BEN}/api-new/doc-payment`;

//ตรวจคำพิพากษา เบล
const POST_MAIN_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/main-jugde-doc`;
const POST_ACCEPT_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/accept-check-jugde`;
const POST_JUDGE_DOC_DETAIL = `${BASE_URL_BEN}/api-new/detail-judge`;
const POST_RECHECK_COMPLETE_JUDGE_DOC = `${BASE_URL_BEN}/api-new/complete-check-jugde`;
const POST_RESEND_COMPLETE_JUDGE_DOC = `${BASE_URL_BEN}/api-new/resend-check-jugde`;

//ตรวจคำพิพากษาเฮีย
const POST_ACCEPT_CEO_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/accept-ceo-check-jugde`;
const POST_CEO_RECHECK_COMPLETE_JUDGE_DOC = `${BASE_URL_BEN}/api-new/complete-ceo-check-jugde`;

//การเงินรับชำระรายวัน
const POST_REPORT_PAYMENT_DAILY = `${BASE_URL_BEN}/auth/report-payment-daily`;
const POST_REPORT_AROTHR_DAILY = `${BASE_URL_BEN}/auth/report-payment-arothr-daily`;
const POST_REPORT_SUMMARY_PAYMENT = `${BASE_URL_BEN}/auth/report-all-payment-date-daily`; //ดูรวม รับปกติ, ลูกหนี้ือื่น ๆ
const POST_CONTNO_PAYMENT_DAILY = `${BASE_URL_BEN}/auth/report-all-payment-daily`; // ดูรายสัญญา

//รายงานการขายผ่อน
const POST_REPORT_SELLING = `${BASE_URL_BEN}/auth/report-sdate-contno`;
const POST_REPORT_SELLING_AND_INSTALLMENTS = `${BASE_URL_BEN}/auth/report-cash-sale-contno`;
const POST_REPORT_DEBIT_BALANCE = `${BASE_URL_BEN}/auth/report-debit-balance`;

// ใบเสร็จเบิกทดลอง
const GET_LOAD_BANK = `${BASE_URL_BEN_NIKKI}/api-lawyer/load-bank`;
const POST_ADVANE_PAY_DB2 = `${BASE_URL_BEN}/api-new/advane-pay-db2`;
const POST_PRINT_ADVANCE_PAY_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/print-advane-pay-db2`;
//ใบเสร็จเคลียร์เบิกทดลอง
const POST_CLEAR_PAYMENT_DB2 = `${BASE_URL_BEN}/api-new/clear-pay-db2`;
const POST_PRINT_CLEAR_PAYMENT_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/print-clear-pay-db2`;

//รายงานตั้งเบิก/เคลียร์เงินทดรอง
const POST_REPORT_DAILY_ADVANCE_PAY_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/report-daily-advane-pay-db2`;
const POST_REPORT_DAILY_ADVANCE_CLEAR_PAY_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/report-daily-clear-pay-db2`;

// memo new
const POST_INSERT_NOTE_NEW = `${BASE_URL_BEN}/api-new/insert-note`;

//เพิ่มรอบส่งใบชำระทำยอม
const POST_ROUND_AGREEMENT = `https://api-area-investigation-1024031113167.asia-southeast1.run.app/api-inv/update-rounddate-jn`; //รอบ
const POST_EMS_AGREEMENT = `https://api-area-investigation-1024031113167.asia-southeast1.run.app/api-inv/update-parcelno-jn`; //ยิง ems

//บัญชีตรวจสอบ
const POST_ACCEPT_ACC_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/accept-acc-check-jugde`;
const POST_COMPLETE_ACC_RECHECK_JUDGE_DOC = `${BASE_URL_BEN}/api-new/complete-acc-check-jugde`;
const POST_CHECK_HD_PAYMENT = `${BASE_URL_BEN_NIKKI}/api-lawyer/check-hd-payment-impound`; //เช็ครับฝาก

const HEADERS_NPL = {
  "X-API-Key": "SMART_NPL_SECRET_2026",
};
const BASE_URL_NPL =
  "https://accounting-npl-api-1024031113167.asia-southeast1.run.app";

//get ตาม phase
const GET_NPL_CLOSE_OLD_CONTNO = `${BASE_URL_NPL}/api/v1/preview-npl/phase1`; //ปิดสัญญาเดิม
const GET_NPL_SELL_JUDGE = `${BASE_URL_NPL}/api/v1/preview-npl/phase2`; //ขายพิพากษา
const GET_NPL_SELL_AGREEMENT = `${BASE_URL_NPL}/api/v1/preview-npl/phase3`; //ขายทำยอม
const GET_NPL_MOVE_IN_OLD_STOCK_CAR = `${BASE_URL_NPL}/api/v1/preview-npl/phase4`; //โอนเข้าสต็อกรถเก่า
const GET_NPL_RECEIVE_PAYMENT = `${BASE_URL_NPL}/api/v1/preview-npl/phase6`; //รับชำระเงิน
const GET_PENDING_SALE_CAR_IMPOUND = `${BASE_URL_NPL}/api/v1/preview-npl/phase7`; //ยึดรอขาย
const GET_SELLING_CAR_IMPOUND = `${BASE_URL_NPL}/api/v1/preview-npl/phase8`; //ขายรถยึด
const GET_DEBT_ANOTHER = `${BASE_URL_NPL}/api/v1/sync-npl/phase9`; //ตั้งลูกหนี้อื่น ๆ

//sync ตาม phase
const POST_NPL_CLOSE_OLD_CONTNO = `${BASE_URL_NPL}/api/v1/sync-npl/phase1?limit=50`; //ปิดสัญญาเดิม
const POST_NPL_SELL_JUDGE = `${BASE_URL_NPL}/api/v1/sync-npl/phase2?limit=50`; //ขายพิพากษา
const POST_NPL_SELL_AGREEMENT = `${BASE_URL_NPL}/api/v1/sync-npl/phase3?limit=50`; //ขายทำยอม
const POST_NPL_MOVE_IN_OLD_STOCK_CAR = `${BASE_URL_NPL}/api/v1/sync-npl/phase4?limit=50`; //โอนเข้าสต็อกรถเก่า
const POST_NPL_RECEIVE_PAYMENT = `${BASE_URL_NPL}/api/v1/sync-npl/phase6?limit=50`; //รับชำระเงิน
const POST_PENDING_SALE_CAR_IMPOUND = `${BASE_URL_NPL}/api/v1/preview-npl/phase7?limit=50`; //ยึดรอขาย
const POST_SELLING_CAR_IMPOUND = `${BASE_URL_NPL}/api/v1/preview-npl/phase8?limit=50`; //ขายรถยึด
const POST_DEBT_ANOTHER = `${BASE_URL_NPL}/api/v1/sync-npl/phase9?limit=50`; //ตั้งลูกหนี้อื่น ๆ

//sync ตาม phase แบบ select
const POST_NPL_SELL_JUDGE_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase2`; //ขายพิพากษา
const POST_NPL_SELL_AGREEMENT_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase3`; //ขายทำยอม
const POST_NPL_MOVE_IN_OLD_STOCK_CAR_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase4`; //โอนเข้าสต็อกรถเก่า
const POST_NPL_RECEIVE_PAYMENT_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase6`; //รับชำระเงิน
const POST_PENDING_SALE_CAR_IMPOUND_SELECT = `${BASE_URL_NPL}/api/v1/preview-npl/phase7`; //ยึดรอขาย
const POST_SELLING_CAR_IMPOUND_SELECT = `${BASE_URL_NPL}/api/v1/preview-npl/phase8`; //ขายรถยึด
const POST_DEBT_ANOTHER_SELECT = `${BASE_URL_NPL}/api/v1/sync-npl/phase9`; //ตั้งลูกหนี้อื่น ๆ

const GET_AMC_STOCK = `${BASE_URL_NPL}/api/v1/preview-amc/stock`; //โอนเข้าสต็อก
const POST_AMC_STOCK_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/stock?limit=50`; //โอนเข้าสต็อก
const POST_AMC_STOCK_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/stock`; //โอนเข้าสต็อก

const GET_AMC_SELL = `${BASE_URL_NPL}/api/v1/preview-amc/sell`; //ขาย/ตั้งลูกหนี้
const POST_AMC_SELL_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/sell?limit=50`; //ขาย/ตั้งลูกหนี้
const POST_AMC_SELL_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/sell`; //ขาย/ตั้งลูกหนี้

const GET_AMC_STOCK_TAX = `${BASE_URL_NPL}/api/v1/preview-amc/stock/tax`; //ตามลงฝังภาษี stock
const POST_AMC_STOCK_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/stock/tax?limit=50`; //ตามลงฝังภาษี stock
const POST_AMC_STOCK_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/stock/tax`; //ตามลงฝังภาษี stock

const GET_AMC_STOCK_SELL = `${BASE_URL_NPL}/api/v1/preview-amc/sell/tax`; //ตามลงฝังภาษีขาย
const POST_AMC_STOCK_SELL_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/sell/tax?limit=50`; //ตามลงฝังภาษีขาย
const POST_AMC_STOCK_SELL_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/sell/tax`; //ตามลงฝังภาษีขาย

//AMC รับเงิน
const GET_AMC_DEPOSIT = `${BASE_URL_NPL}/api/v1/preview-amc/recv?limit=100`; //รับเงินมัดจำ/ดาวน์ ภายใน
const POST_AMC_DEPOSIT_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/recv?limit=50`; //รับเงินมัดจำ/ดาวน์ ภายใน ทั้งหมด
const POST_AMC_DEPOSIT_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/recv`; //รับเงินมัดจำ/ดาวน์ ภายใน แบบเลือก
//ภาษี
const GET_AMC_DEPOSIT_TAX = `${BASE_URL_NPL}/api/v1/preview-amc/recv/tax?limit=100`; //ภาษี
const POST_AMC_DEPOSIT_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/recv/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
const POST_AMC_DEPOSIT_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/recv/tax`; //ภาษี ภายใน แบบเลือก

//AMC ขาย HOS ภายใน
const GET_TO_HOUSING = `${BASE_URL_NPL}/api/v1/preview-amc/to-housing?limit=100`; //ภายใน
const POST_TO_HOUSING_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing?limit=50`; //ภายใน ภายใน ทั้งหมด
const POST_TO_HOUSING_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing`; //ภายใน ภายใน แบบเลือก

//AMC ขาย HOS ภาษี
const GET_TO_HOUSING_TAX = `${BASE_URL_NPL}/api/v1/preview-amc/to-housing/tax?limit=100`; //ภาษี
const POST_TO_HOUSING_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
const POST_TO_HOUSING_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing/tax`; //ภาษี ภายใน แบบ

//HOUSING รับเงินมัดจำ/ดาวน์
//รับเงินมัดจำ/ดาวน์
const GET_HOUSING_DEPOSIT = `${BASE_URL_NPL}/api/v1/preview-housing/all/deposit?limit=100`; //รับเงินมัดจำ/ดาวน์ ภายใน
const POST_HOUSING_DEPOSIT_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/deposit?limit=50`; //รับเงินมัดจำ/ดาวน์ ภายใน ทั้งหมด
const POST_HOUSING_DEPOSIT_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/deposit`; //รับเงินมัดจำ/ดาวน์ ภายใน แบบเลือก
//ภาษี
const GET_HOUSING_DEPOSIT_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/all/deposit/tax?limit=100`; //ภาษี
const POST_HOUSING_DEPOSIT_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/deposit/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
const POST_HOUSING_DEPOSIT_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/deposit/tax`; //ภาษี ภายใน แบบเลือก

//HOUSING ตั้งลูกหนี้/โอนต้นทุน
//รับเงินมัดจำ/ดาวน์
const GET_HOUSING_SELL = `${BASE_URL_NPL}/api/v1/preview-housing/all/sell?limit=100`; //ภายใน
const POST_HOUSING_SELL_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/sell?limit=50`; //ภายใน ทั้งหมด
const POST_HOUSING_SELL_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/sell`; // ภายใน แบบเลือก
//ภาษี
const GET_HOUSING_SELL_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/all/sell/tax?limit=100`; //ภาษี
const POST_HOUSING_SELL_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/sell/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
const POST_HOUSING_SELL_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/sell/tax`; //ภาษี ภายใน แบบเลือก

//HOUSING รับชำระค่างวด
//รับชำระค่างวด
const GET_HOUSING_RECV = `${BASE_URL_NPL}/api/v1/preview-housing/all/recv?limit=100`; //ภายใน
const POST_HOUSING_RECV_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/recv?limit=50`; //ภายใน ทั้งหมด
const POST_HOUSING_RECV_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/recv`; // ภายใน แบบเลือก
//ภาษี
const GET_HOUSING_RECV_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/all/recv/tax?limit=100`; //ภาษี
const POST_HOUSING_RECV_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/all/recv/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
const POST_HOUSING_RECV_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/all/recv/tax`; //ภาษี ภายใน แบบเลือก

//HOUSING เช่า:คืนเงินประกัน/ล่วงหน้า 7/8
//ภายใน
const GET_HOUSING_LEASE_REFUND = `${BASE_URL_NPL}/api/v1/preview-housing/lease/refund?limit=100`; //ภายใน
const POST_HOUSING_LEASE_REFUND_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/refund?limit=50`; //ภายใน ทั้งหมด
const POST_HOUSING_LEASE_REFUND_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/refund`; // ภายใน แบบเลือก

//ภาษี
const GET_HOUSING_LEASE_REFUND_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/lease/refund/tax?limit=100`; //ภาษี
const POST_HOUSING_LEASE_REFUND_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/refund/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
const POST_HOUSING_LEASE_REFUND_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/refund/tax`; //ภาษี ภายใน แบบเลือก

//HOUSING เช่า:เลิกเช่า/แปลงซื้อ 9/10
//ภายใน
const GET_HOUSING_LEASE_CLOSE = `${BASE_URL_NPL}/api/v1/preview-housing/lease/close?limit=100`; //ภายใน
const POST_HOUSING_LEASE_CLOSE_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/close?limit=50`; //ภายใน ทั้งหมด
const POST_HOUSING_LEASE_CLOSE_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/close`; // ภายใน แบบเลือก

//ภาษี
const GET_HOUSING_LEASE_CLOSE_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/lease/close/tax?limit=100`; //ภาษี
const POST_HOUSING_LEASE_CLOSE_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/close/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
const POST_HOUSING_LEASE_CLOSE_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/close/tax`; //ภาษี ภายใน แบบเลือก

//HOUSING เช่า:ลูกหนี้อื่น/รับเงิน 11/12
//ภายใน
const GET_HOUSING_LEASE_OTHER = `${BASE_URL_NPL}/api/v1/preview-housing/lease/other?limit=100`; //ภายใน
const POST_HOUSING_LEASE_OTHER_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/other?limit=50`; //ภายใน ทั้งหมด
const POST_HOUSING_LEASE_OTHER_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/other`; // ภายใน แบบเลือก

//ภาษี
const GET_HOUSING_LEASE_OTHER_TAX = `${BASE_URL_NPL}/api/v1/preview-housing/lease/other/tax?limit=100`; //ภาษี
const POST_HOUSING_LEASE_OTHER_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-housing/lease/other/tax?limit=50`; //ภาษี ภายใน ทั้งหมด
const POST_HOUSING_LEASE_OTHER_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-housing/lease/other/tax`; //ภาษี ภายใน แบบเลือก

//AMC ขายภาษี
const GET_AMC_TAX = `${BASE_URL_NPL}/api/v1/preview-amc/to-housing/amc-tax?limit=100`;
const POST_AMC_TAX_ALL = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing/amc-tax?limit=50`;
const POST_AMC_TAX_SELECT = `${BASE_URL_NPL}/api/v1/sync-amc/to-housing/amc-tax`;

//report
const GET_NPL_REPORT = `${BASE_URL_NPL}/api/v1/export-excel`; //รายงาน

//ตัดจ่าย 1,8
const POST_MAIN_CUT_PAY_FN = `${BASE_URL_BEN}/api-new/main-jugde-fn`;
const POST_CONFIRM_CLOSE_CONTNO = `${BASE_URL_BEN}/api-new/confirm-close-contno`;

//กดยึด
const POST_DEBTS_LAWYER_EFF = `${BASE_URL_BEN_NIKKI}/api-lawyer/debts-lawyer-eff`;

//แม่ทมตั้มเบิกสืบทรัพย์
const POST_MAIN_DTR_PAYMENT = `${BASE_URL_BEN}/api-new/load-inves-expenses`;
const POST_CREATE_PAYMENT_INVESTIGATE = `${BASE_URL_BEN}/api-new/insert-dtr-payment`;
const POST_LOAD_DTR_PAYMENT = `${BASE_URL_BEN}/api-new/load-dtr-payment`;
const POST_EIDT_DTR_PAYMENT = `${BASE_URL_BEN}/api-new/update-money-online`;
const POST_SYNC_DTR_PAYMENT = `${BASE_URL_BEN}/api-new/sync-inves-online`;

//รายงานรับรู้กำไร
const GET_CONFIG_INTEREST = `/api/config`;
const GET_PROFIT_REPORT = `/api/report/profit?`;
const GET_PROFIT_EXPORT = `/api/report/profit/export?`;

const GET_CONFIG_INTEREST_DEV = `https://calculat-interest-i67f6gaaqa-eu.a.run.app/api/config`;
const GET_PROFIT_REPORT_DEV = `https://calculat-interest-i67f6gaaqa-eu.a.run.app/api/report/profit?`;
const GET_PROFIT_EXPORT_DEV = `https://calculat-interest-i67f6gaaqa-eu.a.run.app/api/report/profit/export?`;

//คำนวน IRR รายสัญญา
const GET_PROFIT_BY_CONTNO = `/api/loan/`;
const GET_CALUATE_HISTORY = `/api/calculations/`;
const POST_CALUATE_CONTNO = `/api/calculate-contract/`;
const GET_INSTALLMENTS = `/api/installments/`;
//คำนวนมือ
const POST_CALCULATE_SOD = `/api/sod`;
const POST_CALCULATE_WEIGHTED = `/api/weighted`;
const POST_CALCULATE_IRR = `/api/irr`;

//dashbord ดูงานทนาย
const POST_LAWYER_JOB = `${BASE_URL_BEN}/api-new/load-loan-list`;

// //โยกงานทนาย
const POST_MAIN_CHANGE_JOBS = `${BASE_URL_BEN}/api-new/main-change-jobs`;
const POST_UPDATE_CHANGE_JOBS = `${BASE_URL_BEN}/api-new/update-change-jobs`;

//ข้อมูล user
const GET_USER_NEW = `${BASE_URL_BEN}/api-new/load-all-user`;

//เพิ่มลูกหนี้อื่น ๆ
const GET_LOAD_PAYFORS = `${BASE_URL_BEN}/api-new/load-pay-fors`;
const POST_UPDATE_PAYFORS = `${BASE_URL_BEN}/api-new/create-pay-fors`;

// รายงานรถยึด;
const POST_REPORT_IMPOUND = `${BASE_URL_BEN}/auth/report-impound`;

//ขายรถยึด ธุรการ
const POST_MAIN_SELLING_CAR_IMPOUND = `${BASE_URL_BEN}/auth/load-main-impound`;
const POST_DETAIL_SELLING_CAR_IMPOUND = `${BASE_URL_BEN}/auth/load-detail-impound`;
const POST_CONFIRM_SELLING_CAR_IMPOUND = `${BASE_URL_BEN}/auth/confirm-sale-impound`;

//รานงานพี่ผึ้ง
const POST_REPORT_MANAGER_ACC = `${BASE_URL_BEN}/auth/report-payment-acc-daily`;

// คืนงานทนาย
const POST_ROLLBACK_JOBS_LAWYERS = `${BASE_URL_BEN}/api-new/update-return-work`;

//mongo ตรวจใบเสร็จ
const POST_DATA_CHECK_SALE_IMPOUND =
  "https://api-mongo-lawyer-539174983798.asia-southeast1.run.app/mongo-lawyer/log-sale-impound-dev";
const POST_LOAD_BILL_SALE_IMPOUND =
  "https://api-mongo-lawyer-539174983798.asia-southeast1.run.app/mongo-lawyer/get-log-sale-impound-dev";
//ธุรการ เช็คเสร็จ
const POST_CHECK_DOC_IMPOUND = `${BASE_URL_BEN}/auth/check-doc-impound`;
//การเงิน
const POST_MAIN_SALE_IMPOUND = `${BASE_URL_BEN}/auth/main-sale-impound`;
//การเงินกดรับเงิน
const POST_SALE_IMPOUND = `${BASE_URL_BEN}/auth/sale-impound`;

const GET_STATUS_THAIPOST = `${BASE_URL_BEN}/api-new/load-thaipost-status`;
const GET_DATA_EMS =
  "https://api-area-investigation-1024031113167.asia-southeast1.run.app/api-inv/check-contno/";

const POST_LOST_CONTACT_DEBTS = `${BASE_URL_BEN}/api-new/load-lost-contact-debts`; //ดูข้อมูลค้างงวด
const POST_APPROVED_DUE = `${BASE_URL_BEN}/api-new/create-due-judge`; //ขออนุมัติผ่อนจ่าย (พิพากษา จ่าย 10%)

const POST_JUDGE_BEEYPUP = `${BASE_URL_BEN}/api-new/preview-judge-beeypup`;
const POST_LOAD_DATA_DUEPAYMENT_JUDGE = `${BASE_URL_BEN}/api-new/load-data-duepayment-judge`;

// โหลด พิพากษาปกติ
const POST_LOAD_LOST_CONTACT_JUDGE = `${BASE_URL_BEN}/api-new/load-lost-contact-judge`;

const POST_SEARCH_CONTRACT_LAWYER = `${BASE_URL_BEN}/auth/search-contract-lawyer`; //หารายละเอียดสัญญาตาม ชื่อ-เลขบัตร
const POST_SEARCH_CONTRACT_REGNO = `${BASE_URL_BEN_NIKKI}/api-lawyer/search-contract-by-regno`; //หารายละเอียดสัญญาตาม ทะเบียนรถ

const API_ZACK_APL = `https://api-zack-amc-1024031113167.asia-southeast1.run.app`;
const API_ZACK_CAR_IMPOUND = `https://api-zack-amc-1024031113167.asia-southeast1.run.app`;
// const mainlawyer = `${API_ZACK_APL}/api-amc/main-lawyer`; // main
const mainlawyer =
  "https://shark-app-j9jc9.ondigitalocean.app/debtor/customers/lawsuit-status";
const searchcontracts = `https://apl-backend-1024031113167.asia-southeast1.run.app/api/contracts/search?q=`;
const contractDetail = `${API_ZACK_APL}/auth-amc/contract-detail-borr-code`;
const login_amc = `https://login-api-1024031113167.asia-southeast1.run.app/login-mongo`; // login
const SEND_NOTE_AMC = `${API_ZACK_APL}/api-amc/insert-stock-note`;

const POST_MAIN_LOST_PRE_ENFORCEMENT = `${BASE_URL_BEN}/api-new/pre-enforcement`;
const POST_SEND_PRE_ENFORCEMENT = `${BASE_URL_BEN}/api-new/send-enforcement`;
const POST_LIST_ENFORCEMENT = `${BASE_URL_BEN}/api-new/list-enforcement`;

const POST_LOAD_JUDGE_ASSET = `${BASE_URL_BEN}/api-new/load-judge-asset`;

const POST_SEND_ENFORCEMENT = `${BASE_URL_BEN}/api-new/quick-enforcement`;
const POST_MAIN_ENFORCEMENT = `${BASE_URL_BEN}/api-new/list-enforce-assigned`;

const POST_CHANNGE_JOBS_ENFORCE = `${BASE_URL_BEN}/api-new/change-jobs-enforce`; //เปลี่ยนผู้สืบทรัพย์
const POST_RECEIVE_JOBS_ENFORCE = `${BASE_URL_BEN}/api-new/receive-enforcement`; //รับงาน

const POST_MAIN_ENFORCE_LAWYER = `${BASE_URL_BEN}/api-new/list-enforce-lawyer`; //ทนายออกหมายบังคับ
const POST_UPDATE_ENFORCE_DOC = `${BASE_URL_BEN}/api-new/update-enforce-lawyer-doc`; //ทนายส่งสถานะออกหมายบังคับ

const POST_UPDATE_CUSTOMER = `${BASE_URL_BEN_NIKKI}/api-lawyer/updates-customer-contact`; //อัพเดทข้อมูลลูกค้า
const GET_GEO_DB2 = `${BASE_URL_BEN_NIKKI}/api-lawyer/aumphur-province`; //ดึงจังหวัด,อำเภอ คุณสาธิต

const POST_SEARCH_OLD_CONTNO = `${BASE_URL_BEN}/api-new/load-list-tno`; //หาสัญญาเก่าจากโปรแกรมคุณสาธิต
const POST_WARP_SEND_LAWSUIT = `${BASE_URL_BEN}/api-new/warp-lawsuit`; //วาร์ปส่งฟ้องไม่ต้องมี loan id

const POST_CAR_IMPOUND_TNOTEFL = `${API_ZACK_CAR_IMPOUND}/api-carimpound/TNOTEFL`; //ดึงข้อมูลงานติดตามมีเลขบิล
const POST_CAR_IMPOUND_SUMNOTEFL = `${API_ZACK_CAR_IMPOUND}/api-carimpound/SUMNOTEFL`; //ใบปิดงาน

const POST_MAIN_REFINACE_ENFORCE = `${BASE_URL_BEN}/api-new/main-rejudge`; //รีไฟแนนซ์ พิพากษา
const POST_DETAIL_REFINACE_ENFORCE = `${BASE_URL_BEN}/api-new/load-rejudge`; //รีไฟแนนซ์ พิพากษา
const POST_INSERT_REJUDGE_REQUEST = `${BASE_URL_BEN}/api-new/insert-rejudge-request`; //รีไฟแนนซ์ พิพากษา
const POST_NEW_JUDGEMENT = `${BASE_URL_BEN}/api-new/lawsult-rejudge-admin`; //รีไฟแนนซ์ พิพากษา

const mainlawyer_V2 = `${API_ZACK_APL}/api-amc/main-lawyer`; //AMC แซ็ค

const POST_LOAD_REJUDGE = `${BASE_URL_BEN}/auth/load-detail-rejudge`; //ดูรายละเอียดสัญญาเก่าที่ถูกรีไฟแนนซ์

const POST_INSERT_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/insert-field-collection`;
const POST_LIST_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/list-field-collection`;
const POST_CLOSE_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/close-field-collection`; //ปิดงาน
const POST_INSERT_FIELD_COLLECTION_NOTE = `${BASE_URL_BEN}/api-new/insert-field-collection-note`; //สร้าง note
const POST_LIST_FIELD_COLLECTION_NOTE = `${BASE_URL_BEN}/api-new/list-field-collection-note`; //ดึงข้อมูล note
const POST_FLAG_DOC_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/flag-doc-field-collection`; //ส่งข้อมูลเอกสาร
const POST_ACCEPT_FIELD_COLLECTION = `${BASE_URL_BEN}/api-new/accept-field-collection`; //ชุดนอกรับงาน

const POST_LOAD_RESUE_JUDGE = `${BASE_URL_BEN}/api-new/load-resue-judge`; //ค้นหาสัญญา
const POST_INSERT_RESUE_JUDGE = `${BASE_URL_BEN}/api-new/insert-resue-judge`; //สร้างฟ้องใหม่

const POST_LAWYER_STOCK = `${BASE_URL_BEN}/auth/report-lawyer-stocks`; //สร้างฟ้องใหม่

const POST_INVENTORY_STOCK = `${BASE_URL_BEN}/auth/report-lawyer-stocks-remaining`; //รายงานสินค้าคงเหลือ

const POST_ADD_OTHER_WORK_JUDGE = `${BASE_URL_BEN}/api-new/add-other-work-judge`; //เพิ่มลูกหนี้อื่น ๆเพิ่มเติม

const POST_LAWYER_JOB_RECEIV = `${BASE_URL_BEN}/api-new/report-case-list`; //รายงานงานทนายพร้อมรับชำระ

const POST_CAL_LOAN_CAR = `${BASE_URL_BEN_NIKKI}/api-lawyer/calc-loan`;

// const VERSION = "Version.1.25.13"; //ปรับรับชำระ,postGL
const VERSION = "Version.1.40.2";

export {
  baseUrl,
  GET_LAWYERS_LIST,
  GET_COMPANIES_LIST,
  GET_ROLE_LIST,
  GET_USERS_LIST,
  GET_BY_ID,
  GET_SELL_STATUS,
  LOG_IN,
  REGISTER,
  POST_USER,
  PUT_USER_UPDATE,
  HEADERS_EXPORT,
  HEADERS_EXPORT_BEN,
  HEADERS_LOGIN,
  BASE_URL_BEN,
  BASE_URL_BEN_NIKKI,
  POST_TERMINATE_CONTRACT,
  POST_TERMINATE_CONTRACT_RECORD,
  POST_TERMINATE_BY_CONTRACT,
  POST_LOAN_DB2,
  POST_LOAN_DB2_V2,
  POST_DETAIL_PAYMENT,
  POST_DETAIL_PAYMENT_LEASING,
  POST_PRE_INVESTIGATE_CHECK,
  POST_LOAD_MEMO,
  POST_LOAD_MEMO_NEW,
  POST_UPDATE_EXCEL_MEMO,
  POST_UPDATE_MEMO,
  POST_LITIGATION_FUNDS,
  GET_SELECT_RE_PRINT,
  POST_DATA_RE_PRINT,
  POST_CANCEL_LIST,
  POST_NEW_LOAN,
  POST_UPDATE_PARCEL,
  POST_UPDATE_PARCEL_STATUS,
  POST_PRE_INVESTIGATE,
  POST_CANCEL_HAND_PRE,
  POST_PRE_INVESTIGATE_CANCEL_HAND,
  POST_MAIN_INVESTIGATE_ONLINE,
  POST_LIST_INVESTIGATE_ONLINE,
  PUT_STATUS_INVESTIGATE_ONLINE,
  GET_LIST_INVESTIGATE_ONLINE,
  POST_SEND_RESPONE_INVESTIGATE,
  POST_LIST_ASSET,
  POST_EDIT_ASSET,
  POST_MAIN_ASSET_BY_DATE,
  POST_MAIN_ASSET_BY_CONTNO,
  POST_MAIN_ASSET_BY_STATUS,
  GET_CHECK_JOB_CANCEL_ROUND,
  POST_CHECK_JOB_CANCEL_HAND,
  POST_CHECK_JOB_DETIAL_CANCEL_HAND,
  POST_CHECK_PRE_WCC,
  PUT_STATUS_ROUND,
  POST_CANCEL_HAND,
  PUT_STATUS_SEND,
  POST_LOAD_WCC_DAY,
  POST_CHECK_ADD_CANCEL_HAND,
  GET_LIST_CANCEL_HAND_DATE,
  POST_LOAD_BY_DATE,
  POST_LOAD_BY_QUERY,
  POST_LOAD_MAIN_INVESTIGATION,
  POST_ADD_ASSETTHASLOAN,
  GET_ADD_COORDINATES,
  POST_LOAD_ASSET,
  POST_LOAD_MAIN_ASSET,
  POST_ADD_ASSET,
  DELETE_ASSET,
  DELETE_ASSETLANDAREA,
  EDIT_CUSTOMER_ASSET,
  DELETE_CUSTOMER_ALL_ASSET,
  DELETE_CUSTOMER_ONE_ASSET,
  POST_UPLOAD_IMAGE,
  GET_LOAD_IMAGE,
  DELETE_IMAGE,
  DELETE_IMAGE_NOT_ASSET,
  GET_GEO_ALL,
  POST_LAWSUIT_DETAIL,
  POST_NOTIC_LAWSUIT,
  POST_CREATE_LAWSUIT,
  POST_BACK_CASE_NUMBER,
  POST_UPDATE_EXPENSE,
  POST_ACCEPT_DOC,
  POST_DOC_SUCCESS,
  POST_CHECK_DOC,
  POST_ACCEPT_WORK,
  POST_DOC_STATUS,
  POST_DOC_RESEND,
  POST_ADD_ADDRESS_TR,
  POST_MAIN_LAWYER,
  POST_ACCEPT_LAWYER,
  POST_MAIN_WITHDRAW,
  POST_EXPENSE_LIST,
  POST_UPDATE_BILL,
  POST_MAIN_PAYMENT,
  POST_CLEAR_PAYMENT,
  POST_CHECK_BILL,
  POST_MAIN_ADVANCE_PAY,
  POST_APPROVALADVANE_PAY,
  POST_BILL_DETAIL,
  POST_CLEAR_APPROVAL,
  POST_LOAD_GURANTOR,
  POST_STATUS_JUDGMENT,
  POST_ADD_DEFENDANT,
  POST_UPDATE_ENFORCE_CASE_DATE,
  POST_UPDATE_FINAL_CASE_DATE,
  POST_UPLOAD_IMAGE_NEW,
  GET_LOAD_IMAGE_NEW_ALL,
  GET_LOAD_IMAGE_NEW_BY,
  POST_DELETE_IMAGE_NEW,
  HEADERS_UPIMAGE,
  POST_CONTNO_DETAIL,
  POST_CALCULATE_CONTNO_NEW,
  HEADERS_EXPORT_DETAIL,
  GET_EXPENSES_LIST,
  PUT_EXPENSES,
  PUT_EXPENSES_REFERENCE,
  GET_LAWSUIT_LIST,
  GET_JOB_COUNT,
  POST_CONTNO_DETAIL_SEARCH,
  GET_MAIN_OLD_DATA,
  POST_LOAD_DETAIL_OLD_DATA,
  POST_UPDATE_JUDGE,
  POST_BILL_PAYMENT,
  VERSION,
  POST_MAIN_RECHECK_JUDGE_DOC,
  POST_JUDGE_DOC_DETAIL,
  POST_ACCEPT_RECHECK_JUDGE_DOC,
  POST_RECHECK_COMPLETE_JUDGE_DOC,
  POST_ACCEPT_CEO_RECHECK_JUDGE_DOC,
  POST_CEO_RECHECK_COMPLETE_JUDGE_DOC,
  POST_REPORT_PAYMENT_DAILY,
  POST_REPORT_AROTHR_DAILY,
  POST_PRINT_FLAG,
  POST_REPORT_INVES,
  GET_LOAD_BANK,
  POST_ADVANE_PAY_DB2,
  POST_PRINT_ADVANCE_PAY_DB2,
  POST_CLEAR_PAYMENT_DB2,
  POST_PRINT_CLEAR_PAYMENT_DB2,
  POST_REPORT_DAILY_ADVANCE_PAY_DB2,
  POST_REPORT_DAILY_ADVANCE_CLEAR_PAY_DB2,
  POST_INSERT_NOTE_NEW,
  GET_COMPANIES_LIST_NEW,
  POST_ROUND_AGREEMENT,
  POST_EMS_AGREEMENT,
  POST_ACCEPT_ACC_RECHECK_JUDGE_DOC,
  POST_COMPLETE_ACC_RECHECK_JUDGE_DOC,
  POST_RESEND_COMPLETE_JUDGE_DOC,
  HEADERS_NPL,
  BASE_URL_NPL,
  GET_NPL_CLOSE_OLD_CONTNO,
  GET_NPL_SELL_JUDGE,
  GET_NPL_SELL_AGREEMENT,
  GET_NPL_MOVE_IN_OLD_STOCK_CAR,
  GET_NPL_RECEIVE_PAYMENT,
  POST_NPL_CLOSE_OLD_CONTNO,
  POST_NPL_SELL_JUDGE,
  POST_NPL_SELL_AGREEMENT,
  POST_NPL_MOVE_IN_OLD_STOCK_CAR,
  POST_NPL_RECEIVE_PAYMENT,
  GET_NPL_REPORT,
  POST_MAIN_CUT_PAY_FN,
  POST_CONFIRM_CLOSE_CONTNO,
  POST_DEBTS_LAWYER_EFF,
  POST_APPEAL_LAWYER,
  POST_REPORT_SELLING,
  POST_REPORT_SELLING_AND_INSTALLMENTS,
  POST_CREATE_PAYMENT_INVESTIGATE,
  POST_LOAD_DTR_PAYMENT,
  POST_EIDT_DTR_PAYMENT,
  POST_SYNC_DTR_PAYMENT,
  POST_REPORT_DEBIT_BALANCE,
  POST_LAWYER_JOB,
  GET_USER_NEW,
  POST_MAIN_DTR_PAYMENT,
  GET_CONFIG_INTEREST,
  GET_PROFIT_REPORT,
  GET_PROFIT_EXPORT,
  GET_PROFIT_BY_CONTNO,
  POST_CALUATE_CONTNO,
  GET_CALUATE_HISTORY,
  GET_INSTALLMENTS,
  POST_CALCULATE_SOD,
  POST_CALCULATE_WEIGHTED,
  POST_CALCULATE_IRR,
  GET_CONFIG_INTEREST_DEV,
  GET_PROFIT_REPORT_DEV,
  GET_PROFIT_EXPORT_DEV,
  POST_MAIN_CHANGE_JOBS,
  POST_UPDATE_CHANGE_JOBS,
  POST_LOAD_DATA_DUEPAYMENT,
  POST_PREVIEW_BEEYPUP,
  POST_PREVIEW_JUDGE,
  POST_FOLLOW_CUSTOMER,
  GET_LOAD_PAYFORS,
  POST_UPDATE_PAYFORS,
  POST_REPORT_IMPOUND,
  POST_MAIN_SELLING_CAR_IMPOUND,
  POST_DETAIL_SELLING_CAR_IMPOUND,
  POST_CHECK_HD_PAYMENT,
  POST_CONFIRM_SELLING_CAR_IMPOUND,
  POST_REPORT_MANAGER_ACC,
  POST_ROLLBACK_JOBS_LAWYERS,
  POST_DATA_CHECK_SALE_IMPOUND,
  POST_LOAD_BILL_SALE_IMPOUND,
  POST_CHECK_DOC_IMPOUND,
  POST_MAIN_SALE_IMPOUND,
  POST_SALE_IMPOUND,
  GET_PENDING_SALE_CAR_IMPOUND,
  GET_SELLING_CAR_IMPOUND,
  POST_PENDING_SALE_CAR_IMPOUND,
  POST_SELLING_CAR_IMPOUND,
  GET_STATUS_THAIPOST,
  GET_DATA_EMS,
  POST_REPORT_SUMMARY_PAYMENT,
  POST_CONTNO_PAYMENT_DAILY,
  POST_LOST_CONTACT_DEBTS,
  POST_APPROVED_DUE,
  POST_JUDGE_BEEYPUP,
  POST_LOAD_DATA_DUEPAYMENT_JUDGE,
  POST_LOAD_LOST_CONTACT_JUDGE,
  POST_SEARCH_CONTRACT_LAWYER,
  GET_DEBT_ANOTHER,
  POST_DEBT_ANOTHER,
  POST_NPL_SELL_JUDGE_SELECT,
  POST_NPL_SELL_AGREEMENT_SELECT,
  POST_NPL_MOVE_IN_OLD_STOCK_CAR_SELECT,
  POST_NPL_RECEIVE_PAYMENT_SELECT,
  POST_PENDING_SALE_CAR_IMPOUND_SELECT,
  POST_SELLING_CAR_IMPOUND_SELECT,
  POST_DEBT_ANOTHER_SELECT,
  GET_AMC_STOCK,
  GET_AMC_SELL,
  GET_AMC_STOCK_TAX,
  GET_AMC_STOCK_SELL,
  POST_AMC_STOCK_ALL,
  POST_AMC_SELL_ALL,
  POST_AMC_STOCK_TAX_ALL,
  POST_AMC_STOCK_SELL_ALL,
  POST_AMC_STOCK_SELECT,
  POST_AMC_SELL_SELECT,
  POST_AMC_STOCK_TAX_SELECT,
  POST_AMC_STOCK_SELL_SELECT,
  API_ZACK_APL,
  mainlawyer,
  searchcontracts,
  contractDetail,
  login_amc,
  POST_MAIN_LOST_PRE_ENFORCEMENT,
  POST_SEND_PRE_ENFORCEMENT,
  POST_LIST_ENFORCEMENT,
  POST_LOAD_JUDGE_ASSET,
  POST_SEARCH_CONTRACT_REGNO,
  POST_SEND_ENFORCEMENT,
  SEND_NOTE_AMC,
  POST_MAIN_ENFORCEMENT,
  GET_HOUSING_DEPOSIT,
  POST_HOUSING_DEPOSIT_ALL,
  POST_HOUSING_DEPOSIT_SELECT,
  GET_HOUSING_DEPOSIT_TAX,
  POST_HOUSING_DEPOSIT_TAX_ALL,
  POST_HOUSING_DEPOSIT_TAX_SELECT,
  GET_HOUSING_SELL,
  GET_HOUSING_SELL_TAX,
  POST_HOUSING_SELL_ALL,
  POST_HOUSING_SELL_SELECT,
  POST_HOUSING_SELL_TAX_ALL,
  POST_HOUSING_SELL_TAX_SELECT,
  GET_HOUSING_RECV,
  GET_HOUSING_RECV_TAX,
  POST_HOUSING_RECV_ALL,
  POST_HOUSING_RECV_SELECT,
  POST_HOUSING_RECV_TAX_ALL,
  POST_HOUSING_RECV_TAX_SELECT,
  GET_AMC_DEPOSIT,
  POST_AMC_DEPOSIT_ALL,
  POST_AMC_DEPOSIT_SELECT,
  GET_AMC_DEPOSIT_TAX,
  POST_AMC_DEPOSIT_TAX_ALL,
  POST_AMC_DEPOSIT_TAX_SELECT,
  POST_CHANNGE_JOBS_ENFORCE,
  POST_RECEIVE_JOBS_ENFORCE,
  POST_MAIN_ENFORCE_LAWYER,
  POST_UPDATE_ENFORCE_DOC,
  POST_UPDATE_CUSTOMER,
  GET_GEO_DB2,
  POST_SEARCH_OLD_CONTNO,
  POST_WARP_SEND_LAWSUIT,
  POST_CAR_IMPOUND_TNOTEFL,
  POST_CAR_IMPOUND_SUMNOTEFL,
  POST_MAIN_REFINACE_ENFORCE,
  POST_DETAIL_REFINACE_ENFORCE,
  POST_INSERT_REJUDGE_REQUEST,
  POST_NEW_JUDGEMENT,
  mainlawyer_V2,
  POST_LOAD_REJUDGE,
  POST_INSERT_FIELD_COLLECTION,
  POST_LIST_FIELD_COLLECTION,
  POST_CLOSE_FIELD_COLLECTION,
  POST_INSERT_FIELD_COLLECTION_NOTE,
  POST_LIST_FIELD_COLLECTION_NOTE,
  POST_FLAG_DOC_FIELD_COLLECTION,
  GET_TO_HOUSING,
  POST_TO_HOUSING_ALL,
  POST_TO_HOUSING_SELECT,
  GET_TO_HOUSING_TAX,
  POST_TO_HOUSING_TAX_ALL,
  POST_TO_HOUSING_TAX_SELECT,
  POST_ACCEPT_FIELD_COLLECTION,
  POST_LOAD_RESUE_JUDGE,
  POST_INSERT_RESUE_JUDGE,
  POST_LAWYER_STOCK,
  POST_INVENTORY_STOCK,
  GET_AMC_TAX,
  POST_AMC_TAX_ALL,
  POST_AMC_TAX_SELECT,
  POST_ADD_OTHER_WORK_JUDGE,
  POST_LAWYER_JOB_RECEIV,
  POST_CAL_LOAN_CAR,
  GET_HOUSING_LEASE_REFUND,
  POST_HOUSING_LEASE_REFUND_ALL,
  POST_HOUSING_LEASE_REFUND_SELECT,
  GET_HOUSING_LEASE_REFUND_TAX,
  POST_HOUSING_LEASE_REFUND_TAX_ALL,
  POST_HOUSING_LEASE_REFUND_TAX_SELECT,
  GET_HOUSING_LEASE_CLOSE,
  POST_HOUSING_LEASE_CLOSE_ALL,
  POST_HOUSING_LEASE_CLOSE_SELECT,
  GET_HOUSING_LEASE_CLOSE_TAX,
  POST_HOUSING_LEASE_CLOSE_TAX_ALL,
  POST_HOUSING_LEASE_CLOSE_TAX_SELECT,
  GET_HOUSING_LEASE_OTHER,
  POST_HOUSING_LEASE_OTHER_ALL,
  POST_HOUSING_LEASE_OTHER_SELECT,
  GET_HOUSING_LEASE_OTHER_TAX,
  POST_HOUSING_LEASE_OTHER_TAX_ALL,
  POST_HOUSING_LEASE_OTHER_TAX_SELECT,
};
